(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["feathers"] = factory();else root["feathers"] = factory();
})(this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/
      __webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/
      __webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/
        if (mode & 8) return value;
        /******/
        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/
        var ns = Object.create(null);
        /******/
        __webpack_require__.r(ns);
        /******/
        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/
        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/
        return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __webpack_require__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(__webpack_require__.s = "./src/index.js");
      /******/
    }
    /************************************************************************/
    /******/({
      /***/"../../node_modules/debug/src/browser.js":
      /*!*********************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/debug/src/browser.js ***!
        \*********************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesDebugSrcBrowserJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */(function (process) {
          function _typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }

          /* eslint-env browser */

          /**
           * This is the web browser implementation of `debug()`.
           */
          exports.log = log;
          exports.formatArgs = formatArgs;
          exports.save = save;
          exports.load = load;
          exports.useColors = useColors;
          exports.storage = localstorage();
          /**
           * Colors.
           */

          exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
          /**
           * Currently only WebKit-based Web Inspectors, Firefox >= v31,
           * and the Firebug extension (any Firefox version) are known
           * to support "%c" CSS customizations.
           *
           * TODO: add a `localStorage` variable to explicitly enable/disable colors
           */
          // eslint-disable-next-line complexity

          function useColors() {
            // NB: In an Electron preload script, document will be defined but not fully
            // initialized. Since we know we're in Chrome, we'll just detect this case
            // explicitly
            if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
              return true;
            } // Internet Explorer and Edge do not support colors.

            if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
              return false;
            } // Is webkit? http://stackoverflow.com/a/16459606/376773
            // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632

            return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
            // Is firebug? http://stackoverflow.com/a/398120/376773
            typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
            // Is firefox >= v31?
            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
            typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
            // Double check webkit in userAgent just in case we are in a worker
            typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
          }
          /**
           * Colorize log arguments if enabled.
           *
           * @api public
           */

          function formatArgs(args) {
            args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
            if (!this.useColors) {
              return;
            }
            var c = 'color: ' + this.color;
            args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
            // arguments passed either before or after the %c, so we need to
            // figure out the correct index to insert the CSS into

            var index = 0;
            var lastC = 0;
            args[0].replace(/%[a-zA-Z%]/g, function (match) {
              if (match === '%%') {
                return;
              }
              index++;
              if (match === '%c') {
                // We only are interested in the *last* %c
                // (the user may have provided their own)
                lastC = index;
              }
            });
            args.splice(lastC, 0, c);
          }
          /**
           * Invokes `console.log()` when available.
           * No-op when `console.log` is not a "function".
           *
           * @api public
           */

          function log() {
            var _console;

            // This hackery is required for IE8/9, where
            // the `console.log` function doesn't have 'apply'
            return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
          }
          /**
           * Save `namespaces`.
           *
           * @param {String} namespaces
           * @api private
           */

          function save(namespaces) {
            try {
              if (namespaces) {
                exports.storage.setItem('debug', namespaces);
              } else {
                exports.storage.removeItem('debug');
              }
            } catch (error) {// Swallow
              // XXX (@Qix-) should we be logging these?
            }
          }
          /**
           * Load `namespaces`.
           *
           * @return {String} returns the previously persisted debug modes
           * @api private
           */

          function load() {
            var r;
            try {
              r = exports.storage.getItem('debug');
            } catch (error) {} // Swallow
            // XXX (@Qix-) should we be logging these?
            // If debug isn't set in LS, and we're in Electron, try to load $DEBUG

            if (!r && typeof process !== 'undefined' && 'env' in process) {
              r = process.env.DEBUG;
            }
            return r;
          }
          /**
           * Localstorage attempts to return the localstorage.
           *
           * This is necessary because safari throws
           * when a user disables cookies/localstorage
           * and you attempt to access it.
           *
           * @return {LocalStorage}
           * @api private
           */

          function localstorage() {
            try {
              // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
              // The Browser also has localStorage in the global context.
              return localStorage;
            } catch (error) {// Swallow
              // XXX (@Qix-) should we be logging these?
            }
          }
          module.exports = __webpack_require__( /*! ./common */"../../node_modules/debug/src/common.js")(exports);
          var formatters = module.exports.formatters;
          /**
           * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
           */

          formatters.j = function (v) {
            try {
              return JSON.stringify(v);
            } catch (error) {
              return '[UnexpectedJSONParseError]: ' + error.message;
            }
          };
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__( /*! ./../../process/browser.js */"../../node_modules/process/browser.js"));

        /***/
      },

      /***/"../../node_modules/debug/src/common.js":
      /*!********************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/debug/src/common.js ***!
        \********************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesDebugSrcCommonJs(module, exports, __webpack_require__) {
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          }
        }

        /**
         * This is the common logic for both the Node.js and web browser
         * implementations of `debug()`.
         */
        function setup(env) {
          createDebug.debug = createDebug;
          createDebug.default = createDebug;
          createDebug.coerce = coerce;
          createDebug.disable = disable;
          createDebug.enable = enable;
          createDebug.enabled = enabled;
          createDebug.humanize = __webpack_require__( /*! ms */"../../node_modules/ms/index.js");
          Object.keys(env).forEach(function (key) {
            createDebug[key] = env[key];
          });
          /**
          * Active `debug` instances.
          */

          createDebug.instances = [];
          /**
          * The currently active debug mode names, and names to skip.
          */

          createDebug.names = [];
          createDebug.skips = [];
          /**
          * Map of special "%n" handling functions, for the debug "format" argument.
          *
          * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
          */

          createDebug.formatters = {};
          /**
          * Selects a color for a debug namespace
          * @param {String} namespace The namespace string for the for the debug instance to be colored
          * @return {Number|String} An ANSI color code for the given namespace
          * @api private
          */

          function selectColor(namespace) {
            var hash = 0;
            for (var i = 0; i < namespace.length; i++) {
              hash = (hash << 5) - hash + namespace.charCodeAt(i);
              hash |= 0; // Convert to 32bit integer
            }

            return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
          }
          createDebug.selectColor = selectColor;
          /**
          * Create a debugger with the given `namespace`.
          *
          * @param {String} namespace
          * @return {Function}
          * @api public
          */

          function createDebug(namespace) {
            var prevTime;
            function debug() {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              // Disabled?
              if (!debug.enabled) {
                return;
              }
              var self = debug; // Set `diff` timestamp

              var curr = Number(new Date());
              var ms = curr - (prevTime || curr);
              self.diff = ms;
              self.prev = prevTime;
              self.curr = curr;
              prevTime = curr;
              args[0] = createDebug.coerce(args[0]);
              if (typeof args[0] !== 'string') {
                // Anything else let's inspect with %O
                args.unshift('%O');
              } // Apply any `formatters` transformations

              var index = 0;
              args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') {
                  return match;
                }
                index++;
                var formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                  var val = args[index];
                  match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

                  args.splice(index, 1);
                  index--;
                }
                return match;
              }); // Apply env-specific formatting (colors, etc.)

              createDebug.formatArgs.call(self, args);
              var logFn = self.log || createDebug.log;
              logFn.apply(self, args);
            }
            debug.namespace = namespace;
            debug.enabled = createDebug.enabled(namespace);
            debug.useColors = createDebug.useColors();
            debug.color = selectColor(namespace);
            debug.destroy = destroy;
            debug.extend = extend; // Debug.formatArgs = formatArgs;
            // debug.rawLog = rawLog;
            // env-specific initialization logic for debug instances

            if (typeof createDebug.init === 'function') {
              createDebug.init(debug);
            }
            createDebug.instances.push(debug);
            return debug;
          }
          function destroy() {
            var index = createDebug.instances.indexOf(this);
            if (index !== -1) {
              createDebug.instances.splice(index, 1);
              return true;
            }
            return false;
          }
          function extend(namespace, delimiter) {
            var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
            newDebug.log = this.log;
            return newDebug;
          }
          /**
          * Enables a debug mode by namespaces. This can include modes
          * separated by a colon and wildcards.
          *
          * @param {String} namespaces
          * @api public
          */

          function enable(namespaces) {
            createDebug.save(namespaces);
            createDebug.names = [];
            createDebug.skips = [];
            var i;
            var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
            var len = split.length;
            for (i = 0; i < len; i++) {
              if (!split[i]) {
                // ignore empty strings
                continue;
              }
              namespaces = split[i].replace(/\*/g, '.*?');
              if (namespaces[0] === '-') {
                createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
              } else {
                createDebug.names.push(new RegExp('^' + namespaces + '$'));
              }
            }
            for (i = 0; i < createDebug.instances.length; i++) {
              var instance = createDebug.instances[i];
              instance.enabled = createDebug.enabled(instance.namespace);
            }
          }
          /**
          * Disable debug output.
          *
          * @return {String} namespaces
          * @api public
          */

          function disable() {
            var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
              return '-' + namespace;
            }))).join(',');
            createDebug.enable('');
            return namespaces;
          }
          /**
          * Returns true if the given mode name is enabled, false otherwise.
          *
          * @param {String} name
          * @return {Boolean}
          * @api public
          */

          function enabled(name) {
            if (name[name.length - 1] === '*') {
              return true;
            }
            var i;
            var len;
            for (i = 0, len = createDebug.skips.length; i < len; i++) {
              if (createDebug.skips[i].test(name)) {
                return false;
              }
            }
            for (i = 0, len = createDebug.names.length; i < len; i++) {
              if (createDebug.names[i].test(name)) {
                return true;
              }
            }
            return false;
          }
          /**
          * Convert regexp to namespace
          *
          * @param {RegExp} regxep
          * @return {String} namespace
          * @api private
          */

          function toNamespace(regexp) {
            return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
          }
          /**
          * Coerce `val`.
          *
          * @param {Mixed} val
          * @return {Mixed}
          * @api private
          */

          function coerce(val) {
            if (val instanceof Error) {
              return val.stack || val.message;
            }
            return val;
          }
          createDebug.enable(createDebug.load());
          return createDebug;
        }
        module.exports = setup;

        /***/
      },

      /***/"../../node_modules/events/events.js":
      /*!*****************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/events/events.js ***!
        \*****************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesEventsEventsJs(module, exports, __webpack_require__) {
        "use strict";

        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.
        var R = typeof Reflect === 'object' ? Reflect : null;
        var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
          return Function.prototype.apply.call(target, receiver, args);
        };
        var ReflectOwnKeys;
        if (R && typeof R.ownKeys === 'function') {
          ReflectOwnKeys = R.ownKeys;
        } else if (Object.getOwnPropertySymbols) {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
          };
        } else {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target);
          };
        }
        function ProcessEmitWarning(warning) {
          if (console && console.warn) console.warn(warning);
        }
        var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
          return value !== value;
        };
        function EventEmitter() {
          EventEmitter.init.call(this);
        }
        module.exports = EventEmitter;

        // Backwards-compat with node 0.10.x
        EventEmitter.EventEmitter = EventEmitter;
        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._eventsCount = 0;
        EventEmitter.prototype._maxListeners = undefined;

        // By default EventEmitters will print a warning if more than 10 listeners are
        // added to it. This is a useful default which helps finding memory leaks.
        var defaultMaxListeners = 10;
        function checkListener(listener) {
          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }
        }
        Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
          enumerable: true,
          get: function get() {
            return defaultMaxListeners;
          },
          set: function set(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
              throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            }
            defaultMaxListeners = arg;
          }
        });
        EventEmitter.init = function () {
          if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
          }
          this._maxListeners = this._maxListeners || undefined;
        };

        // Obviously not all Emitters should be limited to 10. This function allows
        // that to be increased. Set to zero for unlimited.
        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
          if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
            throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
          }
          this._maxListeners = n;
          return this;
        };
        function _getMaxListeners(that) {
          if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
          return that._maxListeners;
        }
        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
          return _getMaxListeners(this);
        };
        EventEmitter.prototype.emit = function emit(type) {
          var args = [];
          for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          var doError = type === 'error';
          var events = this._events;
          if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

          // If there is no 'error' event listener then throw.
          if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) {
              // Note: The comments on the `throw` lines are intentional, they show
              // up in Node's output if this results in an unhandled exception.
              throw er; // Unhandled 'error' event
            }
            // At least give some kind of context to the user
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
          }

          var handler = events[type];
          if (handler === undefined) return false;
          if (typeof handler === 'function') {
            ReflectApply(handler, this, args);
          } else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for (var i = 0; i < len; ++i) {
              ReflectApply(listeners[i], this, args);
            }
          }
          return true;
        };
        function _addListener(target, type, listener, prepend) {
          var m;
          var events;
          var existing;
          checkListener(listener);
          events = target._events;
          if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
          } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
              target.emit('newListener', type, listener.listener ? listener.listener : listener);

              // Re-assign `events` because a newListener handler could have caused the
              // this._events to be assigned to a new object
              events = target._events;
            }
            existing = events[type];
          }
          if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
          } else {
            if (typeof existing === 'function') {
              // Adding the second element, need to change to array.
              existing = events[type] = prepend ? [listener, existing] : [existing, listener];
              // If we've already got an array, just append.
            } else if (prepend) {
              existing.unshift(listener);
            } else {
              existing.push(listener);
            }

            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
              existing.warned = true;
              // No error code for this since it is a Warning
              // eslint-disable-next-line no-restricted-syntax
              var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
              w.name = 'MaxListenersExceededWarning';
              w.emitter = target;
              w.type = type;
              w.count = existing.length;
              ProcessEmitWarning(w);
            }
          }
          return target;
        }
        EventEmitter.prototype.addListener = function addListener(type, listener) {
          return _addListener(this, type, listener, false);
        };
        EventEmitter.prototype.on = EventEmitter.prototype.addListener;
        EventEmitter.prototype.prependListener = function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };
        function onceWrapper() {
          if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
          }
        }
        function _onceWrap(target, type, listener) {
          var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
          };
          var wrapped = onceWrapper.bind(state);
          wrapped.listener = listener;
          state.wrapFn = wrapped;
          return wrapped;
        }
        EventEmitter.prototype.once = function once(type, listener) {
          checkListener(listener);
          this.on(type, _onceWrap(this, type, listener));
          return this;
        };
        EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
          checkListener(listener);
          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        };

        // Emits a 'removeListener' event if and only if the listener was removed.
        EventEmitter.prototype.removeListener = function removeListener(type, listener) {
          var list, events, position, i, originalListener;
          checkListener(listener);
          events = this._events;
          if (events === undefined) return this;
          list = events[type];
          if (list === undefined) return this;
          if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);else {
              delete events[type];
              if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;
            for (i = list.length - 1; i >= 0; i--) {
              if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }
            if (position < 0) return this;
            if (position === 0) list.shift();else {
              spliceOne(list, position);
            }
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
          }
          return this;
        };
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
          var listeners, events, i;
          events = this._events;
          if (events === undefined) return this;

          // not listening for removeListener, no need to emit
          if (events.removeListener === undefined) {
            if (arguments.length === 0) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            } else if (events[type] !== undefined) {
              if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
            }
            return this;
          }

          // emit removeListener for all listeners on all events
          if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for (i = 0; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
          }
          listeners = events[type];
          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
              this.removeListener(type, listeners[i]);
            }
          }
          return this;
        };
        function _listeners(target, type, unwrap) {
          var events = target._events;
          if (events === undefined) return [];
          var evlistener = events[type];
          if (evlistener === undefined) return [];
          if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
          return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
        }
        EventEmitter.prototype.listeners = function listeners(type) {
          return _listeners(this, type, true);
        };
        EventEmitter.prototype.rawListeners = function rawListeners(type) {
          return _listeners(this, type, false);
        };
        EventEmitter.listenerCount = function (emitter, type) {
          if (typeof emitter.listenerCount === 'function') {
            return emitter.listenerCount(type);
          } else {
            return listenerCount.call(emitter, type);
          }
        };
        EventEmitter.prototype.listenerCount = listenerCount;
        function listenerCount(type) {
          var events = this._events;
          if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') {
              return 1;
            } else if (evlistener !== undefined) {
              return evlistener.length;
            }
          }
          return 0;
        }
        EventEmitter.prototype.eventNames = function eventNames() {
          return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
        };
        function arrayClone(arr, n) {
          var copy = new Array(n);
          for (var i = 0; i < n; ++i) {
            copy[i] = arr[i];
          }
          return copy;
        }
        function spliceOne(list, index) {
          for (; index + 1 < list.length; index++) {
            list[index] = list[index + 1];
          }
          list.pop();
        }
        function unwrapListeners(arr) {
          var ret = new Array(arr.length);
          for (var i = 0; i < ret.length; ++i) {
            ret[i] = arr[i].listener || arr[i];
          }
          return ret;
        }

        /***/
      },

      /***/"../../node_modules/ms/index.js":
      /*!************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/ms/index.js ***!
        \************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesMsIndexJs(module, exports) {
        /**
         * Helpers.
         */

        var s = 1000;
        var m = s * 60;
        var h = m * 60;
        var d = h * 24;
        var w = d * 7;
        var y = d * 365.25;

        /**
         * Parse or format the given `val`.
         *
         * Options:
         *
         *  - `long` verbose formatting [false]
         *
         * @param {String|Number} val
         * @param {Object} [options]
         * @throws {Error} throw an error if val is not a non-empty string or a number
         * @return {String|Number}
         * @api public
         */

        module.exports = function (val, options) {
          options = options || {};
          var type = typeof val;
          if (type === 'string' && val.length > 0) {
            return parse(val);
          } else if (type === 'number' && isFinite(val)) {
            return options.long ? fmtLong(val) : fmtShort(val);
          }
          throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
        };

        /**
         * Parse the given `str` and return milliseconds.
         *
         * @param {String} str
         * @return {Number}
         * @api private
         */

        function parse(str) {
          str = String(str);
          if (str.length > 100) {
            return;
          }
          var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
          if (!match) {
            return;
          }
          var n = parseFloat(match[1]);
          var type = (match[2] || 'ms').toLowerCase();
          switch (type) {
            case 'years':
            case 'year':
            case 'yrs':
            case 'yr':
            case 'y':
              return n * y;
            case 'weeks':
            case 'week':
            case 'w':
              return n * w;
            case 'days':
            case 'day':
            case 'd':
              return n * d;
            case 'hours':
            case 'hour':
            case 'hrs':
            case 'hr':
            case 'h':
              return n * h;
            case 'minutes':
            case 'minute':
            case 'mins':
            case 'min':
            case 'm':
              return n * m;
            case 'seconds':
            case 'second':
            case 'secs':
            case 'sec':
            case 's':
              return n * s;
            case 'milliseconds':
            case 'millisecond':
            case 'msecs':
            case 'msec':
            case 'ms':
              return n;
            default:
              return undefined;
          }
        }

        /**
         * Short format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtShort(ms) {
          var msAbs = Math.abs(ms);
          if (msAbs >= d) {
            return Math.round(ms / d) + 'd';
          }
          if (msAbs >= h) {
            return Math.round(ms / h) + 'h';
          }
          if (msAbs >= m) {
            return Math.round(ms / m) + 'm';
          }
          if (msAbs >= s) {
            return Math.round(ms / s) + 's';
          }
          return ms + 'ms';
        }

        /**
         * Long format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtLong(ms) {
          var msAbs = Math.abs(ms);
          if (msAbs >= d) {
            return plural(ms, msAbs, d, 'day');
          }
          if (msAbs >= h) {
            return plural(ms, msAbs, h, 'hour');
          }
          if (msAbs >= m) {
            return plural(ms, msAbs, m, 'minute');
          }
          if (msAbs >= s) {
            return plural(ms, msAbs, s, 'second');
          }
          return ms + ' ms';
        }

        /**
         * Pluralization helper.
         */

        function plural(ms, msAbs, n, name) {
          var isPlural = msAbs >= n * 1.5;
          return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
        }

        /***/
      },

      /***/"../../node_modules/process/browser.js":
      /*!*******************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/process/browser.js ***!
        \*******************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesProcessBrowserJs(module, exports) {
        // shim for using process in browser
        var process = module.exports = {};

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;
        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }
        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }
        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;
        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }
        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;
          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }
        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues
        process.versions = {};
        function noop() {}
        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;
        process.listeners = function (name) {
          return [];
        };
        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };
        process.cwd = function () {
          return '/';
        };
        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };
        process.umask = function () {
          return 0;
        };

        /***/
      },

      /***/"../../node_modules/qs/lib/formats.js":
      /*!******************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/qs/lib/formats.js ***!
        \******************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesQsLibFormatsJs(module, exports, __webpack_require__) {
        "use strict";

        var replace = String.prototype.replace;
        var percentTwenties = /%20/g;
        var util = __webpack_require__( /*! ./utils */"../../node_modules/qs/lib/utils.js");
        var Format = {
          RFC1738: 'RFC1738',
          RFC3986: 'RFC3986'
        };
        module.exports = util.assign({
          'default': Format.RFC3986,
          formatters: {
            RFC1738: function RFC1738(value) {
              return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function RFC3986(value) {
              return String(value);
            }
          }
        }, Format);

        /***/
      },

      /***/"../../node_modules/qs/lib/index.js":
      /*!****************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/qs/lib/index.js ***!
        \****************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesQsLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var stringify = __webpack_require__( /*! ./stringify */"../../node_modules/qs/lib/stringify.js");
        var parse = __webpack_require__( /*! ./parse */"../../node_modules/qs/lib/parse.js");
        var formats = __webpack_require__( /*! ./formats */"../../node_modules/qs/lib/formats.js");
        module.exports = {
          formats: formats,
          parse: parse,
          stringify: stringify
        };

        /***/
      },

      /***/"../../node_modules/qs/lib/parse.js":
      /*!****************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/qs/lib/parse.js ***!
        \****************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesQsLibParseJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__( /*! ./utils */"../../node_modules/qs/lib/utils.js");
        var has = Object.prototype.hasOwnProperty;
        var isArray = Array.isArray;
        var defaults = {
          allowDots: false,
          allowPrototypes: false,
          arrayLimit: 20,
          charset: 'utf-8',
          charsetSentinel: false,
          comma: false,
          decoder: utils.decode,
          delimiter: '&',
          depth: 5,
          ignoreQueryPrefix: false,
          interpretNumericEntities: false,
          parameterLimit: 1000,
          parseArrays: true,
          plainObjects: false,
          strictNullHandling: false
        };
        var interpretNumericEntities = function interpretNumericEntities(str) {
          return str.replace(/&#(\d+);/g, function ($0, numberStr) {
            return String.fromCharCode(parseInt(numberStr, 10));
          });
        };

        // This is what browsers will submit when the ✓ character occurs in an
        // application/x-www-form-urlencoded body and the encoding of the page containing
        // the form is iso-8859-1, or when the submitted form has an accept-charset
        // attribute of iso-8859-1. Presumably also with other charsets that do not contain
        // the ✓ character, such as us-ascii.
        var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

        // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
        var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

        var parseValues = function parseQueryStringValues(str, options) {
          var obj = {};
          var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
          var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
          var parts = cleanStr.split(options.delimiter, limit);
          var skipIndex = -1; // Keep track of where the utf8 sentinel was found
          var i;
          var charset = options.charset;
          if (options.charsetSentinel) {
            for (i = 0; i < parts.length; ++i) {
              if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                  charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                  charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
              }
            }
          }

          for (i = 0; i < parts.length; ++i) {
            if (i === skipIndex) {
              continue;
            }
            var part = parts[i];
            var bracketEqualsPos = part.indexOf(']=');
            var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
            var key, val;
            if (pos === -1) {
              key = options.decoder(part, defaults.decoder, charset, 'key');
              val = options.strictNullHandling ? null : '';
            } else {
              key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
              val = options.decoder(part.slice(pos + 1), defaults.decoder, charset, 'value');
            }
            if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
              val = interpretNumericEntities(val);
            }
            if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
              val = val.split(',');
            }
            if (part.indexOf('[]=') > -1) {
              val = isArray(val) ? [val] : val;
            }
            if (has.call(obj, key)) {
              obj[key] = utils.combine(obj[key], val);
            } else {
              obj[key] = val;
            }
          }
          return obj;
        };
        var parseObject = function parseObject(chain, val, options) {
          var leaf = val;
          for (var i = chain.length - 1; i >= 0; --i) {
            var obj;
            var root = chain[i];
            if (root === '[]' && options.parseArrays) {
              obj = [].concat(leaf);
            } else {
              obj = options.plainObjects ? Object.create(null) : {};
              var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
              var index = parseInt(cleanRoot, 10);
              if (!options.parseArrays && cleanRoot === '') {
                obj = {
                  0: leaf
                };
              } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
              } else {
                obj[cleanRoot] = leaf;
              }
            }
            leaf = obj;
          }
          return leaf;
        };
        var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
          if (!givenKey) {
            return;
          }

          // Transform dot notation to bracket notation
          var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

          // The regex chunks

          var brackets = /(\[[^[\]]*])/;
          var child = /(\[[^[\]]*])/g;

          // Get the parent

          var segment = options.depth > 0 && brackets.exec(key);
          var parent = segment ? key.slice(0, segment.index) : key;

          // Stash the parent if it exists

          var keys = [];
          if (parent) {
            // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
            if (!options.plainObjects && has.call(Object.prototype, parent)) {
              if (!options.allowPrototypes) {
                return;
              }
            }
            keys.push(parent);
          }

          // Loop through children appending to the array until we hit depth

          var i = 0;
          while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
            i += 1;
            if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
              if (!options.allowPrototypes) {
                return;
              }
            }
            keys.push(segment[1]);
          }

          // If there's a remainder, just add whatever is left

          if (segment) {
            keys.push('[' + key.slice(segment.index) + ']');
          }
          return parseObject(keys, val, options);
        };
        var normalizeParseOptions = function normalizeParseOptions(opts) {
          if (!opts) {
            return defaults;
          }
          if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
            throw new TypeError('Decoder has to be a function.');
          }
          if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
            throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
          }
          var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
          return {
            allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
            allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
            arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
            charset: charset,
            charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
            comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
            decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
            delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
            // eslint-disable-next-line no-implicit-coercion, no-extra-parens
            depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
            ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
            interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
            parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
            parseArrays: opts.parseArrays !== false,
            plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
            strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
          };
        };
        module.exports = function (str, opts) {
          var options = normalizeParseOptions(opts);
          if (str === '' || str === null || typeof str === 'undefined') {
            return options.plainObjects ? Object.create(null) : {};
          }
          var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
          var obj = options.plainObjects ? Object.create(null) : {};

          // Iterate over the keys and setup the new object

          var keys = Object.keys(tempObj);
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var newObj = parseKeys(key, tempObj[key], options);
            obj = utils.merge(obj, newObj, options);
          }
          return utils.compact(obj);
        };

        /***/
      },

      /***/"../../node_modules/qs/lib/stringify.js":
      /*!********************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/qs/lib/stringify.js ***!
        \********************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesQsLibStringifyJs(module, exports, __webpack_require__) {
        "use strict";

        var utils = __webpack_require__( /*! ./utils */"../../node_modules/qs/lib/utils.js");
        var formats = __webpack_require__( /*! ./formats */"../../node_modules/qs/lib/formats.js");
        var has = Object.prototype.hasOwnProperty;
        var arrayPrefixGenerators = {
          brackets: function brackets(prefix) {
            return prefix + '[]';
          },
          comma: 'comma',
          indices: function indices(prefix, key) {
            return prefix + '[' + key + ']';
          },
          repeat: function repeat(prefix) {
            return prefix;
          }
        };
        var isArray = Array.isArray;
        var push = Array.prototype.push;
        var pushToArray = function pushToArray(arr, valueOrArray) {
          push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
        };
        var toISO = Date.prototype.toISOString;
        var defaultFormat = formats['default'];
        var defaults = {
          addQueryPrefix: false,
          allowDots: false,
          charset: 'utf-8',
          charsetSentinel: false,
          delimiter: '&',
          encode: true,
          encoder: utils.encode,
          encodeValuesOnly: false,
          format: defaultFormat,
          formatter: formats.formatters[defaultFormat],
          // deprecated
          indices: false,
          serializeDate: function serializeDate(date) {
            return toISO.call(date);
          },
          skipNulls: false,
          strictNullHandling: false
        };
        var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
          return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
        };
        var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
          var obj = object;
          if (typeof filter === 'function') {
            obj = filter(prefix, obj);
          } else if (obj instanceof Date) {
            obj = serializeDate(obj);
          } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
            obj = obj.join(',');
          }
          if (obj === null) {
            if (strictNullHandling) {
              return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
            }
            obj = '';
          }
          if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
            if (encoder) {
              var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
              return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
            }
            return [formatter(prefix) + '=' + formatter(String(obj))];
          }
          var values = [];
          if (typeof obj === 'undefined') {
            return values;
          }
          var objKeys;
          if (isArray(filter)) {
            objKeys = filter;
          } else {
            var keys = Object.keys(obj);
            objKeys = sort ? keys.sort(sort) : keys;
          }
          for (var i = 0; i < objKeys.length; ++i) {
            var key = objKeys[i];
            if (skipNulls && obj[key] === null) {
              continue;
            }
            if (isArray(obj)) {
              pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
            } else {
              pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
            }
          }
          return values;
        };
        var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
          if (!opts) {
            return defaults;
          }
          if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
            throw new TypeError('Encoder has to be a function.');
          }
          var charset = opts.charset || defaults.charset;
          if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
            throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
          }
          var format = formats['default'];
          if (typeof opts.format !== 'undefined') {
            if (!has.call(formats.formatters, opts.format)) {
              throw new TypeError('Unknown format option provided.');
            }
            format = opts.format;
          }
          var formatter = formats.formatters[format];
          var filter = defaults.filter;
          if (typeof opts.filter === 'function' || isArray(opts.filter)) {
            filter = opts.filter;
          }
          return {
            addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
            allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
            charset: charset,
            charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
            delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
            encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
            encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
            encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
            filter: filter,
            formatter: formatter,
            serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
            skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
            sort: typeof opts.sort === 'function' ? opts.sort : null,
            strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
          };
        };
        module.exports = function (object, opts) {
          var obj = object;
          var options = normalizeStringifyOptions(opts);
          var objKeys;
          var filter;
          if (typeof options.filter === 'function') {
            filter = options.filter;
            obj = filter('', obj);
          } else if (isArray(options.filter)) {
            filter = options.filter;
            objKeys = filter;
          }
          var keys = [];
          if (typeof obj !== 'object' || obj === null) {
            return '';
          }
          var arrayFormat;
          if (opts && opts.arrayFormat in arrayPrefixGenerators) {
            arrayFormat = opts.arrayFormat;
          } else if (opts && 'indices' in opts) {
            arrayFormat = opts.indices ? 'indices' : 'repeat';
          } else {
            arrayFormat = 'indices';
          }
          var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
          if (!objKeys) {
            objKeys = Object.keys(obj);
          }
          if (options.sort) {
            objKeys.sort(options.sort);
          }
          for (var i = 0; i < objKeys.length; ++i) {
            var key = objKeys[i];
            if (options.skipNulls && obj[key] === null) {
              continue;
            }
            pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
          }
          var joined = keys.join(options.delimiter);
          var prefix = options.addQueryPrefix === true ? '?' : '';
          if (options.charsetSentinel) {
            if (options.charset === 'iso-8859-1') {
              // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
              prefix += 'utf8=%26%2310003%3B&';
            } else {
              // encodeURIComponent('✓')
              prefix += 'utf8=%E2%9C%93&';
            }
          }
          return joined.length > 0 ? prefix + joined : '';
        };

        /***/
      },

      /***/"../../node_modules/qs/lib/utils.js":
      /*!****************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/qs/lib/utils.js ***!
        \****************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesQsLibUtilsJs(module, exports, __webpack_require__) {
        "use strict";

        var has = Object.prototype.hasOwnProperty;
        var isArray = Array.isArray;
        var hexTable = function () {
          var array = [];
          for (var i = 0; i < 256; ++i) {
            array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
          }
          return array;
        }();
        var compactQueue = function compactQueue(queue) {
          while (queue.length > 1) {
            var item = queue.pop();
            var obj = item.obj[item.prop];
            if (isArray(obj)) {
              var compacted = [];
              for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                  compacted.push(obj[j]);
                }
              }
              item.obj[item.prop] = compacted;
            }
          }
        };
        var arrayToObject = function arrayToObject(source, options) {
          var obj = options && options.plainObjects ? Object.create(null) : {};
          for (var i = 0; i < source.length; ++i) {
            if (typeof source[i] !== 'undefined') {
              obj[i] = source[i];
            }
          }
          return obj;
        };
        var merge = function merge(target, source, options) {
          /* eslint no-param-reassign: 0 */
          if (!source) {
            return target;
          }
          if (typeof source !== 'object') {
            if (isArray(target)) {
              target.push(source);
            } else if (target && typeof target === 'object') {
              if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
                target[source] = true;
              }
            } else {
              return [target, source];
            }
            return target;
          }
          if (!target || typeof target !== 'object') {
            return [target].concat(source);
          }
          var mergeTarget = target;
          if (isArray(target) && !isArray(source)) {
            mergeTarget = arrayToObject(target, options);
          }
          if (isArray(target) && isArray(source)) {
            source.forEach(function (item, i) {
              if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                  target[i] = merge(targetItem, item, options);
                } else {
                  target.push(item);
                }
              } else {
                target[i] = item;
              }
            });
            return target;
          }
          return Object.keys(source).reduce(function (acc, key) {
            var value = source[key];
            if (has.call(acc, key)) {
              acc[key] = merge(acc[key], value, options);
            } else {
              acc[key] = value;
            }
            return acc;
          }, mergeTarget);
        };
        var assign = function assignSingleSource(target, source) {
          return Object.keys(source).reduce(function (acc, key) {
            acc[key] = source[key];
            return acc;
          }, target);
        };
        var decode = function decode(str, decoder, charset) {
          var strWithoutPlus = str.replace(/\+/g, ' ');
          if (charset === 'iso-8859-1') {
            // unescape never throws, no try...catch needed:
            return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
          }
          // utf-8
          try {
            return decodeURIComponent(strWithoutPlus);
          } catch (e) {
            return strWithoutPlus;
          }
        };
        var encode = function encode(str, defaultEncoder, charset) {
          // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
          // It has been adapted here for stricter adherence to RFC 3986
          if (str.length === 0) {
            return str;
          }
          var string = str;
          if (typeof str === 'symbol') {
            string = Symbol.prototype.toString.call(str);
          } else if (typeof str !== 'string') {
            string = String(str);
          }
          if (charset === 'iso-8859-1') {
            return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
              return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
            });
          }
          var out = '';
          for (var i = 0; i < string.length; ++i) {
            var c = string.charCodeAt(i);
            if (c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || c >= 0x30 && c <= 0x39 // 0-9
            || c >= 0x41 && c <= 0x5A // a-z
            || c >= 0x61 && c <= 0x7A // A-Z
            ) {
              out += string.charAt(i);
              continue;
            }
            if (c < 0x80) {
              out = out + hexTable[c];
              continue;
            }
            if (c < 0x800) {
              out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
              continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
              out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
              continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
            out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
          }
          return out;
        };
        var compact = function compact(value) {
          var queue = [{
            obj: {
              o: value
            },
            prop: 'o'
          }];
          var refs = [];
          for (var i = 0; i < queue.length; ++i) {
            var item = queue[i];
            var obj = item.obj[item.prop];
            var keys = Object.keys(obj);
            for (var j = 0; j < keys.length; ++j) {
              var key = keys[j];
              var val = obj[key];
              if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                  obj: obj,
                  prop: key
                });
                refs.push(val);
              }
            }
          }
          compactQueue(queue);
          return value;
        };
        var isRegExp = function isRegExp(obj) {
          return Object.prototype.toString.call(obj) === '[object RegExp]';
        };
        var isBuffer = function isBuffer(obj) {
          if (!obj || typeof obj !== 'object') {
            return false;
          }
          return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
        };
        var combine = function combine(a, b) {
          return [].concat(a, b);
        };
        module.exports = {
          arrayToObject: arrayToObject,
          assign: assign,
          combine: combine,
          compact: compact,
          decode: decode,
          encode: encode,
          isBuffer: isBuffer,
          isRegExp: isRegExp,
          merge: merge
        };

        /***/
      },

      /***/"../../node_modules/uberproto/lib/proto.js":
      /*!***********************************************************************************!*\
        !*** /Users/davidluecke/Development/feathers/node_modules/uberproto/lib/proto.js ***!
        \***********************************************************************************/
      /*! no static exports found */
      /***/
      function node_modulesUberprotoLibProtoJs(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /* global define */
        /**
         * Uberproto
         *
         * A base object for ECMAScript 5 style prototypal inheritance.
         *
         * @see https://github.com/rauschma/proto-js/
         * @see http://ejohn.org/blog/simple-javascript-inheritance/
         * @see http://uxebu.com/blog/2011/02/23/object-based-inheritance-for-ecmascript-5/
         */
        (function (root, factory) {
          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })(this, function () {
          var HAS_SYMBOLS = typeof Object.getOwnPropertySymbols === 'function';
          function makeSuper(_super, old, name, fn) {
            var isFunction = typeof old === 'function';
            var newMethod = function newMethod() {
              var tmp = this._super;

              // Add a new ._super() method that is the same method
              // but either pointing to the prototype method
              // or to the overwritten method
              this._super = isFunction ? old : _super[name];

              // The method only need to be bound temporarily, so we
              // remove it when we're done executing
              var ret = fn.apply(this, arguments);
              this._super = tmp;
              return ret;
            };
            if (isFunction && HAS_SYMBOLS) {
              Object.getOwnPropertySymbols(old).forEach(function (name) {
                newMethod[name] = old[name];
              });
            }
            return newMethod;
          }
          return {
            /**
             * Create a new object using Object.create. The arguments will be
             * passed to the new instances init method or to a method name set in
             * __init.
             */
            create: function create() {
              var instance = Object.create(this);
              var init = typeof instance.__init === 'string' ? instance.__init : 'init';
              if (typeof instance[init] === 'function') {
                instance[init].apply(instance, arguments);
              }
              return instance;
            },
            /**
             * Mixin a given set of properties
             * @param prop The properties to mix in
             * @param obj [optional]
             * The object to add the mixin
             */
            mixin: function mixin(prop, obj) {
              var self = obj || this;
              var fnTest = /\b_super\b/;
              var _super = Object.getPrototypeOf(self) || self.prototype;
              var descriptors = {};
              var proto = prop;
              var processProperty = function processProperty(name) {
                var descriptor = Object.getOwnPropertyDescriptor(proto, name);
                if (!descriptors[name] && descriptor) {
                  descriptors[name] = descriptor;
                }
              };

              // Collect all property descriptors
              do {
                Object.getOwnPropertyNames(proto).forEach(processProperty);
                if (HAS_SYMBOLS) {
                  Object.getOwnPropertySymbols(proto).forEach(processProperty);
                }
              } while ((proto = Object.getPrototypeOf(proto)) && Object.getPrototypeOf(proto));
              var processDescriptor = function processDescriptor(name) {
                var descriptor = descriptors[name];
                if (typeof descriptor.value === 'function' && fnTest.test(descriptor.value)) {
                  descriptor.value = makeSuper(_super, self[name], name, descriptor.value);
                }
                Object.defineProperty(self, name, descriptor);
              };
              Object.keys(descriptors).forEach(processDescriptor);
              if (HAS_SYMBOLS) {
                Object.getOwnPropertySymbols(descriptors).forEach(processDescriptor);
              }
              return self;
            },
            /**
             * Extend the current or a given object with the given property and return the extended object.
             * @param prop The properties to extend with
             * @param obj [optional] The object to extend from
             * @returns The extended object
             */
            extend: function extend(prop, obj) {
              return this.mixin(prop, Object.create(obj || this));
            },
            /**
             * Return a callback function with this set to the current or a given context object.
             * @param name Name of the method to proxy
             * @param args... [optional] Arguments to use for partial application
             */
            proxy: function proxy(name) {
              var fn = this[name];
              var args = Array.prototype.slice.call(arguments, 1);
              args.unshift(this);
              return fn.bind.apply(fn, args);
            }
          };
        });

        /***/
      },

      /***/"../authentication-client/lib/core.js":
      /*!********************************************!*\
        !*** ../authentication-client/lib/core.js ***!
        \********************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibCoreJs(module, exports, __webpack_require__) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _slicedToArray(arr, i) {
          return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
        }
        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        function _iterableToArrayLimit(arr, i) {
          if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
            return;
          }
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;
          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);
              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }
          return _arr;
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var errors_1 = __webpack_require__( /*! @feathersjs/errors */"../errors/lib/index.js");
        var storage_1 = __webpack_require__( /*! ./storage */"../authentication-client/lib/storage.js");
        var getMatch = function getMatch(location, key) {
          var regex = new RegExp("(?:&?)".concat(key, "=([^&]*)"));
          var match = location.hash ? location.hash.match(regex) : null;
          if (match !== null) {
            var _match = _slicedToArray(match, 2),
              value = _match[1];
            return [value, regex];
          }
          return [null, regex];
        };
        var AuthenticationClient = /*#__PURE__*/
        function () {
          function AuthenticationClient(app, options) {
            _classCallCheck(this, AuthenticationClient);
            var socket = app.io || app.primus;
            var storage = new storage_1.StorageWrapper(app.get('storage') || options.storage);
            this.app = app;
            this.options = options;
            this.authenticated = false;
            this.app.set('storage', storage);
            if (socket) {
              this.handleSocket(socket);
            }
          }
          _createClass(AuthenticationClient, [{
            key: "handleSocket",
            value: function handleSocket(socket) {
              var _this = this;

              // Connection events happen on every reconnect
              var connected = this.app.io ? 'connect' : 'open';
              var disconnected = this.app.io ? 'disconnect' : 'disconnection';
              socket.on(disconnected, function () {
                var authPromise = new Promise(function (resolve) {
                  return socket.once(connected, function () {
                    return resolve();
                  });
                }) // Only reconnect when `reAuthenticate()` or `authenticate()`
                // has been called explicitly first
                // Force reauthentication with the server
                .then(function () {
                  return _this.authenticated ? _this.reAuthenticate(true) : null;
                });
                _this.app.set('authentication', authPromise);
              });
            }
          }, {
            key: "getFromLocation",
            value: function getFromLocation(location) {
              var _getMatch = getMatch(location, this.options.locationKey),
                _getMatch2 = _slicedToArray(_getMatch, 2),
                accessToken = _getMatch2[0],
                tokenRegex = _getMatch2[1];
              if (accessToken !== null) {
                location.hash = location.hash.replace(tokenRegex, '');
                return Promise.resolve(accessToken);
              }
              var _getMatch3 = getMatch(location, this.options.locationErrorKey),
                _getMatch4 = _slicedToArray(_getMatch3, 2),
                message = _getMatch4[0],
                errorRegex = _getMatch4[1];
              if (message !== null) {
                location.hash = location.hash.replace(errorRegex, '');
                return Promise.reject(new errors_1.NotAuthenticated(decodeURIComponent(message)));
              }
              return Promise.resolve(null);
            }
          }, {
            key: "setAccessToken",
            value: function setAccessToken(accessToken) {
              return this.storage.setItem(this.options.storageKey, accessToken);
            }
          }, {
            key: "getAccessToken",
            value: function getAccessToken() {
              var _this2 = this;
              return this.storage.getItem(this.options.storageKey).then(function (accessToken) {
                if (!accessToken && typeof window !== 'undefined' && window.location) {
                  return _this2.getFromLocation(window.location);
                }
                return accessToken || null;
              });
            }
          }, {
            key: "removeAccessToken",
            value: function removeAccessToken() {
              return this.storage.removeItem(this.options.storageKey);
            }
          }, {
            key: "reset",
            value: function reset() {
              this.app.set('authentication', null);
              this.authenticated = false;
              return Promise.resolve(null);
            }
          }, {
            key: "handleError",
            value: function handleError(error, type) {
              var _this3 = this;
              if (error.code === 401 || error.code === 403) {
                var promise = this.removeAccessToken().then(function () {
                  return _this3.reset();
                });
                return type === 'logout' ? promise : promise.then(function () {
                  return Promise.reject(error);
                });
              }
              return Promise.reject(error);
            }
          }, {
            key: "reAuthenticate",
            value: function reAuthenticate() {
              var _this4 = this;
              var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              // Either returns the authentication state or
              // tries to re-authenticate with the stored JWT and strategy
              var authPromise = this.app.get('authentication');
              if (!authPromise || force === true) {
                return this.getAccessToken().then(function (accessToken) {
                  if (!accessToken) {
                    throw new errors_1.NotAuthenticated('No accessToken found in storage');
                  }
                  return _this4.authenticate({
                    strategy: _this4.options.jwtStrategy,
                    accessToken: accessToken
                  });
                });
              }
              return authPromise;
            }
          }, {
            key: "authenticate",
            value: function authenticate(authentication, params) {
              var _this5 = this;
              if (!authentication) {
                return this.reAuthenticate();
              }
              var promise = this.service.create(authentication, params).then(function (authResult) {
                var accessToken = authResult.accessToken;
                _this5.authenticated = true;
                _this5.app.emit('login', authResult);
                _this5.app.emit('authenticated', authResult);
                return _this5.setAccessToken(accessToken).then(function () {
                  return authResult;
                });
              }).catch(function (error) {
                return _this5.handleError(error, 'authenticate');
              });
              this.app.set('authentication', promise);
              return promise;
            }
          }, {
            key: "logout",
            value: function logout() {
              var _this6 = this;
              return Promise.resolve(this.app.get('authentication')).then(function () {
                return _this6.service.remove(null).then(function (authResult) {
                  return _this6.removeAccessToken().then(function () {
                    return _this6.reset();
                  }).then(function () {
                    _this6.app.emit('logout', authResult);
                    return authResult;
                  });
                });
              }).catch(function (error) {
                return _this6.handleError(error, 'logout');
              });
            }
          }, {
            key: "service",
            get: function get() {
              return this.app.service(this.options.path);
            }
          }, {
            key: "storage",
            get: function get() {
              return this.app.get('storage');
            }
          }]);
          return AuthenticationClient;
        }();
        exports.AuthenticationClient = AuthenticationClient;

        /***/
      },

      /***/"../authentication-client/lib/hooks/authentication.js":
      /*!************************************************************!*\
        !*** ../authentication-client/lib/hooks/authentication.js ***!
        \************************************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibHooksAuthenticationJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var commons_1 = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js");
        exports.authentication = function () {
          return function (context) {
            var app = context.app,
              params = context.params,
              path = context.path,
              method = context.method,
              service = context.app.authentication;
            if (commons_1.stripSlashes(service.options.path) === path && method === 'create') {
              return context;
            }
            return Promise.resolve(app.get('authentication')).then(function (authResult) {
              if (authResult) {
                context.params = Object.assign({}, authResult, params);
              }
              return context;
            });
          };
        };

        /***/
      },

      /***/"../authentication-client/lib/hooks/index.js":
      /*!***************************************************!*\
        !*** ../authentication-client/lib/hooks/index.js ***!
        \***************************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibHooksIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var authentication_1 = __webpack_require__( /*! ./authentication */"../authentication-client/lib/hooks/authentication.js");
        exports.authentication = authentication_1.authentication;
        var populate_header_1 = __webpack_require__( /*! ./populate-header */"../authentication-client/lib/hooks/populate-header.js");
        exports.populateHeader = populate_header_1.populateHeader;

        /***/
      },

      /***/"../authentication-client/lib/hooks/populate-header.js":
      /*!*************************************************************!*\
        !*** ../authentication-client/lib/hooks/populate-header.js ***!
        \*************************************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibHooksPopulateHeaderJs(module, exports, __webpack_require__) {
        "use strict";

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.populateHeader = function () {
          return function (context) {
            var app = context.app,
              accessToken = context.params.accessToken;
            var authentication = app.authentication; // Set REST header if necessary

            if (app.rest && accessToken) {
              var _authentication$optio = authentication.options,
                scheme = _authentication$optio.scheme,
                header = _authentication$optio.header;
              var authHeader = "".concat(scheme, " ").concat(accessToken);
              context.params.headers = Object.assign({}, _defineProperty({}, header, authHeader), context.params.headers);
            }
            return context;
          };
        };

        /***/
      },

      /***/"../authentication-client/lib/index.js":
      /*!*********************************************!*\
        !*** ../authentication-client/lib/index.js ***!
        \*********************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var __importStar = this && this.__importStar || function (mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) {
            if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          }
          result["default"] = mod;
          return result;
        };
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var core_1 = __webpack_require__( /*! ./core */"../authentication-client/lib/core.js");
        exports.AuthenticationClient = core_1.AuthenticationClient;
        var hooks = __importStar(__webpack_require__( /*! ./hooks */"../authentication-client/lib/hooks/index.js"));
        exports.hooks = hooks;
        var storage_1 = __webpack_require__( /*! ./storage */"../authentication-client/lib/storage.js");
        exports.MemoryStorage = storage_1.MemoryStorage;
        exports.getDefaultStorage = function () {
          try {
            return new storage_1.StorageWrapper(window.localStorage);
          } catch (error) {}
          return new storage_1.MemoryStorage();
        };
        exports.defaultStorage = exports.getDefaultStorage();
        exports.defaults = {
          header: 'Authorization',
          scheme: 'Bearer',
          storageKey: 'feathers-jwt',
          locationKey: 'access_token',
          locationErrorKey: 'error',
          jwtStrategy: 'jwt',
          path: '/authentication',
          Authentication: core_1.AuthenticationClient,
          storage: exports.defaultStorage
        };
        var init = function init() {
          var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = Object.assign({}, exports.defaults, _options);
          var Authentication = options.Authentication;
          return function (app) {
            var authentication = new Authentication(app, options);
            app.authentication = authentication;
            app.authenticate = authentication.authenticate.bind(authentication);
            app.reAuthenticate = authentication.reAuthenticate.bind(authentication);
            app.logout = authentication.logout.bind(authentication);
            app.hooks({
              before: {
                all: [hooks.authentication(), hooks.populateHeader()]
              }
            });
          };
        };
        exports.default = init;
        if (true) {
          module.exports = Object.assign(init, module.exports);
        }

        /***/
      },

      /***/"../authentication-client/lib/storage.js":
      /*!***********************************************!*\
        !*** ../authentication-client/lib/storage.js ***!
        \***********************************************/
      /*! no static exports found */
      /***/
      function authenticationClientLibStorageJs(module, exports, __webpack_require__) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var MemoryStorage = /*#__PURE__*/
        function () {
          function MemoryStorage() {
            _classCallCheck(this, MemoryStorage);
            this.store = {};
          }
          _createClass(MemoryStorage, [{
            key: "getItem",
            value: function getItem(key) {
              return Promise.resolve(this.store[key]);
            }
          }, {
            key: "setItem",
            value: function setItem(key, value) {
              return Promise.resolve(this.store[key] = value);
            }
          }, {
            key: "removeItem",
            value: function removeItem(key) {
              var value = this.store[key];
              delete this.store[key];
              return Promise.resolve(value);
            }
          }]);
          return MemoryStorage;
        }();
        exports.MemoryStorage = MemoryStorage;
        var StorageWrapper = /*#__PURE__*/
        function () {
          function StorageWrapper(storage) {
            _classCallCheck(this, StorageWrapper);
            this.storage = storage;
          }
          _createClass(StorageWrapper, [{
            key: "getItem",
            value: function getItem(key) {
              return Promise.resolve(this.storage.getItem(key));
            }
          }, {
            key: "setItem",
            value: function setItem(key, value) {
              return Promise.resolve(this.storage.setItem(key, value));
            }
          }, {
            key: "removeItem",
            value: function removeItem(key) {
              return Promise.resolve(this.storage.removeItem(key));
            }
          }]);
          return StorageWrapper;
        }();
        exports.StorageWrapper = StorageWrapper;

        /***/
      },

      /***/"../commons/lib/hooks.js":
      /*!*******************************!*\
        !*** ../commons/lib/hooks.js ***!
        \*******************************/
      /*! no static exports found */
      /***/
      function commonsLibHooksJs(module, exports, __webpack_require__) {
        "use strict";

        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var utils_1 = __webpack_require__( /*! ./utils */"../commons/lib/utils.js");
        var _utils_1$_ = utils_1._,
          each = _utils_1$_.each,
          pick = _utils_1$_.pick;
        exports.ACTIVATE_HOOKS = utils_1.createSymbol('__feathersActivateHooks');
        function createHookObject(method) {
          var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var hook = {};
          Object.defineProperty(hook, 'toJSON', {
            value: function value() {
              return pick(this, 'type', 'method', 'path', 'params', 'id', 'data', 'result', 'error');
            }
          });
          return Object.assign(hook, data, {
            method: method,
            // A dynamic getter that returns the path of the service
            get path() {
              var app = data.app,
                service = data.service;
              if (!service || !app || !app.services) {
                return null;
              }
              return Object.keys(app.services).find(function (path) {
                return app.services[path] === service;
              });
            }
          });
        }
        exports.createHookObject = createHookObject; // Fallback used by `makeArguments` which usually won't be used

        function defaultMakeArguments(hook) {
          var result = [];
          if (typeof hook.id !== 'undefined') {
            result.push(hook.id);
          }
          if (hook.data) {
            result.push(hook.data);
          }
          result.push(hook.params || {});
          return result;
        }
        exports.defaultMakeArguments = defaultMakeArguments; // Turns a hook object back into a list of arguments
        // to call a service method with

        function makeArguments(hook) {
          switch (hook.method) {
            case 'find':
              return [hook.params];
            case 'get':
            case 'remove':
              return [hook.id, hook.params];
            case 'update':
            case 'patch':
              return [hook.id, hook.data, hook.params];
            case 'create':
              return [hook.data, hook.params];
          }
          return defaultMakeArguments(hook);
        }
        exports.makeArguments = makeArguments; // Converts different hook registration formats into the
        // same internal format

        function convertHookData(obj) {
          var hook = {};
          if (Array.isArray(obj)) {
            hook = {
              all: obj
            };
          } else if (_typeof(obj) !== 'object') {
            hook = {
              all: [obj]
            };
          } else {
            each(obj, function (value, key) {
              hook[key] = !Array.isArray(value) ? [value] : value;
            });
          }
          return hook;
        }
        exports.convertHookData = convertHookData; // Duck-checks a given object to be a hook object
        // A valid hook object has `type` and `method`

        function isHookObject(hookObject) {
          return _typeof(hookObject) === 'object' && typeof hookObject.method === 'string' && typeof hookObject.type === 'string';
        }
        exports.isHookObject = isHookObject; // Returns all service and application hooks combined
        // for a given method and type `appLast` sets if the hooks
        // from `app` should be added last (or first by default)

        function getHooks(app, service, type, method) {
          var appLast = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          var appHooks = app.__hooks[type][method] || [];
          var serviceHooks = service.__hooks[type][method] || [];
          if (appLast) {
            // Run hooks in the order of service -> app -> finally
            return serviceHooks.concat(appHooks);
          }
          return appHooks.concat(serviceHooks);
        }
        exports.getHooks = getHooks;
        function processHooks(hooks, initialHookObject) {
          var _this = this;
          var hookObject = initialHookObject;
          var updateCurrentHook = function updateCurrentHook(current) {
            // Either use the returned hook object or the current
            // hook object from the chain if the hook returned undefined
            if (current) {
              if (!isHookObject(current)) {
                throw new Error("".concat(hookObject.type, " hook for '").concat(hookObject.method, "' method returned invalid hook object"));
              }
              hookObject = current;
            }
            return hookObject;
          }; // Go through all hooks and chain them into our promise

          var promise = hooks.reduce(function (current, fn) {
            // @ts-ignore
            var hook = fn.bind(_this); // Use the returned hook object or the old one

            return current.then(function (currentHook) {
              return hook(currentHook);
            }).then(updateCurrentHook);
          }, Promise.resolve(hookObject));
          return promise.then(function () {
            return hookObject;
          }).catch(function (error) {
            // Add the hook information to any errors
            error.hook = hookObject;
            throw error;
          });
        }
        exports.processHooks = processHooks; // Add `.hooks` functionality to an object

        function enableHooks(obj, methods, types) {
          if (typeof obj.hooks === 'function') {
            return obj;
          }
          var hookData = {};
          types.forEach(function (type) {
            // Initialize properties where hook functions are stored
            hookData[type] = {};
          }); // Add non-enumerable `__hooks` property to the object

          Object.defineProperty(obj, '__hooks', {
            configurable: true,
            value: hookData,
            writable: true
          });
          return Object.assign(obj, {
            hooks: function hooks(allHooks) {
              var _this2 = this;
              each(allHooks, function (current, type) {
                // @ts-ignore
                if (!_this2.__hooks[type]) {
                  throw new Error("'".concat(type, "' is not a valid hook type"));
                }
                var hooks = convertHookData(current);
                each(hooks, function (_value, method) {
                  if (method !== 'all' && methods.indexOf(method) === -1) {
                    throw new Error("'".concat(method, "' is not a valid hook method"));
                  }
                });
                methods.forEach(function (method) {
                  // @ts-ignore
                  var myHooks = _this2.__hooks[type][method] || (_this2.__hooks[type][method] = []);
                  if (hooks.all) {
                    myHooks.push.apply(myHooks, hooks.all);
                  }
                  if (hooks[method]) {
                    myHooks.push.apply(myHooks, hooks[method]);
                  }
                });
              });
              return this;
            }
          });
        }
        exports.enableHooks = enableHooks;

        /***/
      },

      /***/"../commons/lib/index.js":
      /*!*******************************!*\
        !*** ../commons/lib/index.js ***!
        \*******************************/
      /*! no static exports found */
      /***/
      function commonsLibIndexJs(module, exports, __webpack_require__) {
        "use strict";

        function __export(m) {
          for (var p in m) {
            if (!exports.hasOwnProperty(p)) exports[p] = m[p];
          }
        }
        var __importStar = this && this.__importStar || function (mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) {
            if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          }
          result["default"] = mod;
          return result;
        };
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var hookUtils = __importStar(__webpack_require__( /*! ./hooks */"../commons/lib/hooks.js"));
        __export(__webpack_require__( /*! ./utils */"../commons/lib/utils.js"));
        exports.hooks = hookUtils;

        /***/
      },

      /***/"../commons/lib/utils.js":
      /*!*******************************!*\
        !*** ../commons/lib/utils.js ***!
        \*******************************/
      /*! no static exports found */
      /***/
      function commonsLibUtilsJs(module, exports, __webpack_require__) {
        "use strict";

        /* WEBPACK VAR INJECTION */
        (function (process) {
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _typeof(obj) {
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof = function _typeof(obj) {
                return typeof obj;
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };
            }
            return _typeof(obj);
          }
          function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
          }
          function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
          function _iterableToArrayLimit(arr, i) {
            if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
              return;
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"] != null) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
          }
          Object.defineProperty(exports, "__esModule", {
            value: true
          }); // Removes all leading and trailing slashes from a path

          function stripSlashes(name) {
            return name.replace(/^(\/+)|(\/+)$/g, '');
          }
          exports.stripSlashes = stripSlashes; // A set of lodash-y utility functions that use ES6

          exports._ = {
            each: function each(obj, callback) {
              if (obj && typeof obj.forEach === 'function') {
                obj.forEach(callback);
              } else if (exports._.isObject(obj)) {
                Object.keys(obj).forEach(function (key) {
                  return callback(obj[key], key);
                });
              }
            },
            some: function some(value, callback) {
              return Object.keys(value).map(function (key) {
                return [value[key], key];
              }).some(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  val = _ref2[0],
                  key = _ref2[1];
                return callback(val, key);
              });
            },
            every: function every(value, callback) {
              return Object.keys(value).map(function (key) {
                return [value[key], key];
              }).every(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  val = _ref4[0],
                  key = _ref4[1];
                return callback(val, key);
              });
            },
            keys: function keys(obj) {
              return Object.keys(obj);
            },
            values: function values(obj) {
              return exports._.keys(obj).map(function (key) {
                return obj[key];
              });
            },
            isMatch: function isMatch(obj, item) {
              return exports._.keys(item).every(function (key) {
                return obj[key] === item[key];
              });
            },
            isEmpty: function isEmpty(obj) {
              return exports._.keys(obj).length === 0;
            },
            isObject: function isObject(item) {
              return _typeof(item) === 'object' && !Array.isArray(item) && item !== null;
            },
            isObjectOrArray: function isObjectOrArray(value) {
              return _typeof(value) === 'object' && value !== null;
            },
            extend: function extend(first) {
              for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                rest[_key - 1] = arguments[_key];
              }
              return Object.assign.apply(Object, [first].concat(rest));
            },
            omit: function omit(obj) {
              var result = exports._.extend({}, obj);
              for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                keys[_key2 - 1] = arguments[_key2];
              }
              keys.forEach(function (key) {
                return delete result[key];
              });
              return result;
            },
            pick: function pick(source) {
              for (var _len3 = arguments.length, keys = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                keys[_key3 - 1] = arguments[_key3];
              }
              return keys.reduce(function (result, key) {
                if (source[key] !== undefined) {
                  result[key] = source[key];
                }
                return result;
              }, {});
            },
            // Recursively merge the source object into the target object
            merge: function merge(target, source) {
              if (exports._.isObject(target) && exports._.isObject(source)) {
                Object.keys(source).forEach(function (key) {
                  if (exports._.isObject(source[key])) {
                    if (!target[key]) {
                      Object.assign(target, _defineProperty({}, key, {}));
                    }
                    exports._.merge(target[key], source[key]);
                  } else {
                    Object.assign(target, _defineProperty({}, key, source[key]));
                  }
                });
              }
              return target;
            }
          }; // Duck-checks if an object looks like a promise

          function isPromise(result) {
            return exports._.isObject(result) && typeof result.then === 'function';
          }
          exports.isPromise = isPromise;
          function makeUrl(path) {
            var app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var get = typeof app.get === 'function' ? app.get.bind(app) : function () {};
            var env = get('env') || "development";
            var host = get('host') || process.env.HOST_NAME || 'localhost';
            var protocol = env === 'development' || env === 'test' || env === undefined ? 'http' : 'https';
            var PORT = get('port') || process.env.PORT || 3030;
            var port = env === 'development' || env === 'test' || env === undefined ? ":".concat(PORT) : '';
            path = path || '';
            return "".concat(protocol, "://").concat(host).concat(port, "/").concat(exports.stripSlashes(path));
          }
          exports.makeUrl = makeUrl;
          function createSymbol(name) {
            return typeof Symbol !== 'undefined' ? Symbol(name) : name;
          }
          exports.createSymbol = createSymbol;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__( /*! ./../../../node_modules/process/browser.js */"../../node_modules/process/browser.js"));

        /***/
      },

      /***/"../errors/lib/index.js":
      /*!******************************!*\
        !*** ../errors/lib/index.js ***!
        \******************************/
      /*! no static exports found */
      /***/
      function errorsLibIndexJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        var debug = __webpack_require__( /*! debug */"../../node_modules/debug/src/browser.js")('@feathersjs/errors');
        function FeathersError(msg, name, code, className, data) {
          msg = msg || 'Error';
          var errors;
          var message;
          var newData;
          if (msg instanceof Error) {
            message = msg.message || 'Error'; // NOTE (EK): This is typically to handle validation errors

            if (msg.errors) {
              errors = msg.errors;
            }
          } else if (_typeof(msg) === 'object') {
            // Support plain old objects
            message = msg.message || 'Error';
            data = msg;
          } else {
            // message is just a string
            message = msg;
          }
          if (data) {
            // NOTE(EK): To make sure that we are not messing
            // with immutable data, just make a copy.
            // https://github.com/feathersjs/errors/issues/19
            newData = JSON.parse(JSON.stringify(data));
            if (newData.errors) {
              errors = newData.errors;
              delete newData.errors;
            } else if (data.errors) {
              // The errors property from data could be
              // stripped away while cloning resulting newData not to have it
              // For example: when cloning arrays this property
              errors = JSON.parse(JSON.stringify(data.errors));
            }
          } // NOTE (EK): Babel doesn't support this so
          // we have to pass in the class name manually.
          // this.name = this.constructor.name;

          this.type = 'FeathersError';
          this.name = name;
          this.message = message;
          this.code = code;
          this.className = className;
          this.data = newData;
          this.errors = errors || {};
          debug("".concat(this.name, "(").concat(this.code, "): ").concat(this.message));
          debug(this.errors);
          if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FeathersError);
          } else {
            this.stack = new Error().stack;
          }
        }
        function inheritsFrom(Child, Parent) {
          Child.prototype = Object.create(Parent.prototype);
          Child.prototype.constructor = Child;
        }
        inheritsFrom(FeathersError, Error); // NOTE (EK): A little hack to get around `message` not
        // being included in the default toJSON call.

        Object.defineProperty(FeathersError.prototype, 'toJSON', {
          value: function value() {
            return {
              name: this.name,
              message: this.message,
              code: this.code,
              className: this.className,
              data: this.data,
              errors: this.errors
            };
          }
        }); // 400 - Bad Request

        function BadRequest(message, data) {
          FeathersError.call(this, message, 'BadRequest', 400, 'bad-request', data);
        }
        inheritsFrom(BadRequest, FeathersError); // 401 - Not Authenticated

        function NotAuthenticated(message, data) {
          FeathersError.call(this, message, 'NotAuthenticated', 401, 'not-authenticated', data);
        }
        inheritsFrom(NotAuthenticated, FeathersError); // 402 - Payment Error

        function PaymentError(message, data) {
          FeathersError.call(this, message, 'PaymentError', 402, 'payment-error', data);
        }
        inheritsFrom(PaymentError, FeathersError); // 403 - Forbidden

        function Forbidden(message, data) {
          FeathersError.call(this, message, 'Forbidden', 403, 'forbidden', data);
        }
        inheritsFrom(Forbidden, FeathersError); // 404 - Not Found

        function NotFound(message, data) {
          FeathersError.call(this, message, 'NotFound', 404, 'not-found', data);
        }
        inheritsFrom(NotFound, FeathersError); // 405 - Method Not Allowed

        function MethodNotAllowed(message, data) {
          FeathersError.call(this, message, 'MethodNotAllowed', 405, 'method-not-allowed', data);
        }
        inheritsFrom(MethodNotAllowed, FeathersError); // 406 - Not Acceptable

        function NotAcceptable(message, data) {
          FeathersError.call(this, message, 'NotAcceptable', 406, 'not-acceptable', data);
        }
        inheritsFrom(NotAcceptable, FeathersError); // 408 - Timeout

        function Timeout(message, data) {
          FeathersError.call(this, message, 'Timeout', 408, 'timeout', data);
        }
        inheritsFrom(Timeout, FeathersError); // 409 - Conflict

        function Conflict(message, data) {
          FeathersError.call(this, message, 'Conflict', 409, 'conflict', data);
        }
        inheritsFrom(Conflict, FeathersError); // 411 - Length Required

        function LengthRequired(message, data) {
          FeathersError.call(this, message, 'LengthRequired', 411, 'length-required', data);
        }
        inheritsFrom(LengthRequired, FeathersError); // 422 Unprocessable

        function Unprocessable(message, data) {
          FeathersError.call(this, message, 'Unprocessable', 422, 'unprocessable', data);
        }
        inheritsFrom(Unprocessable, FeathersError); // 429 Too Many Requests

        function TooManyRequests(message, data) {
          FeathersError.call(this, message, 'TooManyRequests', 429, 'too-many-requests', data);
        }
        inheritsFrom(TooManyRequests, FeathersError); // 500 - General Error

        function GeneralError(message, data) {
          FeathersError.call(this, message, 'GeneralError', 500, 'general-error', data);
        }
        inheritsFrom(GeneralError, FeathersError); // 501 - Not Implemented

        function NotImplemented(message, data) {
          FeathersError.call(this, message, 'NotImplemented', 501, 'not-implemented', data);
        }
        inheritsFrom(NotImplemented, FeathersError); // 502 - Bad Gateway

        function BadGateway(message, data) {
          FeathersError.call(this, message, 'BadGateway', 502, 'bad-gateway', data);
        }
        inheritsFrom(BadGateway, FeathersError); // 503 - Unavailable

        function Unavailable(message, data) {
          FeathersError.call(this, message, 'Unavailable', 503, 'unavailable', data);
        }
        inheritsFrom(Unavailable, FeathersError);
        var errors = {
          FeathersError: FeathersError,
          BadRequest: BadRequest,
          NotAuthenticated: NotAuthenticated,
          PaymentError: PaymentError,
          Forbidden: Forbidden,
          NotFound: NotFound,
          MethodNotAllowed: MethodNotAllowed,
          NotAcceptable: NotAcceptable,
          Timeout: Timeout,
          Conflict: Conflict,
          LengthRequired: LengthRequired,
          Unprocessable: Unprocessable,
          TooManyRequests: TooManyRequests,
          GeneralError: GeneralError,
          NotImplemented: NotImplemented,
          BadGateway: BadGateway,
          Unavailable: Unavailable,
          400: BadRequest,
          401: NotAuthenticated,
          402: PaymentError,
          403: Forbidden,
          404: NotFound,
          405: MethodNotAllowed,
          406: NotAcceptable,
          408: Timeout,
          409: Conflict,
          411: LengthRequired,
          422: Unprocessable,
          429: TooManyRequests,
          500: GeneralError,
          501: NotImplemented,
          502: BadGateway,
          503: Unavailable
        };
        function convert(error) {
          if (!error) {
            return error;
          }
          var FeathersError = errors[error.name];
          var result = FeathersError ? new FeathersError(error.message, error.data) : new Error(error.message || error);
          if (_typeof(error) === 'object') {
            Object.assign(result, error);
          }
          return result;
        }
        module.exports = Object.assign({
          convert: convert
        }, errors);

        /***/
      },

      /***/"../feathers/lib/application.js":
      /*!**************************************!*\
        !*** ../feathers/lib/application.js ***!
        \**************************************/
      /*! no static exports found */
      /***/
      function feathersLibApplicationJs(module, exports, __webpack_require__) {
        var debug = __webpack_require__( /*! debug */"../../node_modules/debug/src/browser.js")('feathers:application');
        var _require = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js"),
          stripSlashes = _require.stripSlashes;
        var Uberproto = __webpack_require__( /*! uberproto */"../../node_modules/uberproto/lib/proto.js");
        var events = __webpack_require__( /*! ./events */"../feathers/lib/events.js");
        var hooks = __webpack_require__( /*! ./hooks */"../feathers/lib/hooks/index.js");
        var version = __webpack_require__( /*! ./version */"../feathers/lib/version.js");
        var Proto = Uberproto.extend({
          create: null
        });
        var application = {
          init: function init() {
            Object.assign(this, {
              version: version,
              methods: ['find', 'get', 'create', 'update', 'patch', 'remove'],
              mixins: [],
              services: {},
              providers: [],
              _setup: false,
              settings: {}
            });
            this.configure(hooks());
            this.configure(events());
          },
          get: function get(name) {
            return this.settings[name];
          },
          set: function set(name, value) {
            this.settings[name] = value;
            return this;
          },
          disable: function disable(name) {
            this.settings[name] = false;
            return this;
          },
          disabled: function disabled(name) {
            return !this.settings[name];
          },
          enable: function enable(name) {
            this.settings[name] = true;
            return this;
          },
          enabled: function enabled(name) {
            return !!this.settings[name];
          },
          configure: function configure(fn) {
            fn.call(this, this);
            return this;
          },
          service: function service(path, _service) {
            if (typeof _service !== 'undefined') {
              throw new Error('Registering a new service with `app.service(path, service)` is no longer supported. Use `app.use(path, service)` instead.');
            }
            var location = stripSlashes(path) || '/';
            var current = this.services[location];
            if (typeof current === 'undefined' && typeof this.defaultService === 'function') {
              return this.use(location, this.defaultService(location)).service(location);
            }
            return current;
          },
          use: function use(path, service) {
            var _this = this;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (typeof path !== 'string') {
              throw new Error("'".concat(path, "' is not a valid service path."));
            }
            var location = stripSlashes(path) || '/';
            var isSubApp = typeof service.service === 'function' && service.services;
            var isService = this.methods.concat('setup').some(function (name) {
              return typeof service[name] === 'function';
            });
            if (isSubApp) {
              var subApp = service;
              Object.keys(subApp.services).forEach(function (subPath) {
                return _this.use("".concat(location, "/").concat(subPath), subApp.service(subPath));
              });
              return this;
            }
            if (!isService) {
              throw new Error("Invalid service object passed for path `".concat(location, "`"));
            } // If the service is already Uberproto'd use it directly

            var protoService = Proto.isPrototypeOf(service) ? service : Proto.extend(service);
            debug("Registering new service at `".concat(location, "`")); // Add all the mixins

            this.mixins.forEach(function (fn) {
              return fn.call(_this, protoService, location, options);
            });
            if (typeof protoService._setup === 'function') {
              protoService._setup(this, location);
            } // Run the provider functions to register the service

            this.providers.forEach(function (provider) {
              return provider.call(_this, protoService, location, options);
            }); // If we ran setup already, set this service up explicitly

            if (this._isSetup && typeof protoService.setup === 'function') {
              debug("Setting up service for `".concat(location, "`"));
              protoService.setup(this, location);
            }
            this.services[location] = protoService;
            return this;
          },
          setup: function setup() {
            var _this2 = this;

            // Setup each service (pass the app so that they can look up other services etc.)
            Object.keys(this.services).forEach(function (path) {
              var service = _this2.services[path];
              debug("Setting up service for `".concat(path, "`"));
              if (typeof service.setup === 'function') {
                service.setup(_this2, path);
              }
            });
            this._isSetup = true;
            return this;
          }
        };
        module.exports = application;

        /***/
      },

      /***/"../feathers/lib/events.js":
      /*!*********************************!*\
        !*** ../feathers/lib/events.js ***!
        \*********************************/
      /*! no static exports found */
      /***/
      function feathersLibEventsJs(module, exports, __webpack_require__) {
        var _require = __webpack_require__( /*! events */"../../node_modules/events/events.js"),
          EventEmitter = _require.EventEmitter;
        var Proto = __webpack_require__( /*! uberproto */"../../node_modules/uberproto/lib/proto.js"); // Returns a hook that emits service events. Should always be
        // used as the very last hook in the chain

        var eventHook = exports.eventHook = function eventHook() {
          return function (hook) {
            var app = hook.app,
              service = hook.service;
            var eventName = hook.event === null ? hook.event : app.eventMappings[hook.method];
            var isHookEvent = service._hookEvents && service._hookEvents.indexOf(eventName) !== -1; // If this event is not being sent yet and we are not in an error hook

            if (eventName && isHookEvent && hook.type !== 'error') {
              var results = Array.isArray(hook.result) ? hook.result : [hook.result];
              results.forEach(function (element) {
                return service.emit(eventName, element, hook);
              });
            }
          };
        }; // Mixin that turns a service into a Node event emitter

        var eventMixin = exports.eventMixin = function eventMixin(service) {
          if (service._serviceEvents) {
            return;
          }
          var app = this; // Indicates if the service is already an event emitter

          var isEmitter = typeof service.on === 'function' && typeof service.emit === 'function'; // If not, mix it in (the service is always an Uberproto object that has a .mixin)

          if (typeof service.mixin === 'function' && !isEmitter) {
            service.mixin(EventEmitter.prototype);
          } // Define non-enumerable properties of

          Object.defineProperties(service, {
            // A list of all events that this service sends
            _serviceEvents: {
              value: Array.isArray(service.events) ? service.events.slice() : []
            },
            // A list of events that should be handled through the event hooks
            _hookEvents: {
              value: []
            }
          }); // `app.eventMappings` has the mapping from method name to event name

          Object.keys(app.eventMappings).forEach(function (method) {
            var event = app.eventMappings[method];
            var alreadyEmits = service._serviceEvents.indexOf(event) !== -1; // Add events for known methods to _serviceEvents and _hookEvents
            // if the service indicated it does not send it itself yet

            if (typeof service[method] === 'function' && !alreadyEmits) {
              service._serviceEvents.push(event);
              service._hookEvents.push(event);
            }
          });
        };
        module.exports = function () {
          return function (app) {
            // Mappings from service method to event name
            Object.assign(app, {
              eventMappings: {
                create: 'created',
                update: 'updated',
                remove: 'removed',
                patch: 'patched'
              }
            }); // Register the event hook
            // `finally` hooks always run last after `error` and `after` hooks

            app.hooks({
              finally: eventHook()
            }); // Make the app an event emitter

            Proto.mixin(EventEmitter.prototype, app);
            app.mixins.push(eventMixin);
          };
        };

        /***/
      },

      /***/"../feathers/lib/hooks/base.js":
      /*!*************************************!*\
        !*** ../feathers/lib/hooks/base.js ***!
        \*************************************/
      /*! no static exports found */
      /***/
      function feathersLibHooksBaseJs(module, exports, __webpack_require__) {
        var _require = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js"),
          _ = _require._;
        var assignArguments = function assignArguments(context) {
          var service = context.service,
            method = context.method;
          var parameters = service.methods[method];
          context.arguments.forEach(function (value, index) {
            context[parameters[index]] = value;
          });
          if (!context.params) {
            context.params = {};
          }
          return context;
        };
        var validate = function validate(context) {
          var service = context.service,
            method = context.method,
            path = context.path;
          var parameters = service.methods[method];
          if (parameters.includes('id') && context.id === undefined) {
            throw new Error("An id must be provided to the '".concat(path, ".").concat(method, "' method"));
          }
          if (parameters.includes('data') && !_.isObjectOrArray(context.data)) {
            throw new Error("A data object must be provided to the '".concat(path, ".").concat(method, "' method"));
          }
          return context;
        };
        module.exports = [assignArguments, validate];

        /***/
      },

      /***/"../feathers/lib/hooks/index.js":
      /*!**************************************!*\
        !*** ../feathers/lib/hooks/index.js ***!
        \**************************************/
      /*! no static exports found */
      /***/
      function feathersLibHooksIndexJs(module, exports, __webpack_require__) {
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          }
        }
        var _require = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js"),
          hooks = _require.hooks,
          isPromise = _require.isPromise;
        var baseHooks = __webpack_require__( /*! ./base */"../feathers/lib/hooks/base.js");
        var createHookObject = hooks.createHookObject,
          getHooks = hooks.getHooks,
          processHooks = hooks.processHooks,
          enableHooks = hooks.enableHooks,
          ACTIVATE_HOOKS = hooks.ACTIVATE_HOOKS;
        var withHooks = function withHooks(_ref) {
          var app = _ref.app,
            service = _ref.service,
            method = _ref.method,
            original = _ref.original;
          return function () {
            var _hooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var hooks = app.hookTypes.reduce(function (result, type) {
              var value = _hooks[type] || [];
              result[type] = Array.isArray(value) ? value : [value];
              return result;
            }, {});
            return function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              var returnHook = args[args.length - 1] === true ? args.pop() : false; // Create the hook object that gets passed through

              var hookObject = createHookObject(method, {
                type: 'before',
                // initial hook object type
                arguments: args,
                service: service,
                app: app
              });
              return Promise.resolve(hookObject) // Run `before` hooks
              .then(function (hookObject) {
                return processHooks.call(service, baseHooks.concat(hooks.before), hookObject);
              }) // Run the original method
              .then(function (hookObject) {
                // If `hookObject.result` is set, skip the original method
                if (typeof hookObject.result !== 'undefined') {
                  return hookObject;
                } // Otherwise, call it with arguments created from the hook object

                var promise = new Promise(function (resolve) {
                  var func = original || service[method];
                  var args = service.methods[method].map(function (value) {
                    return hookObject[value];
                  });
                  var result = func.apply(service, args);
                  if (!isPromise(result)) {
                    throw new Error("Service method '".concat(hookObject.method, "' for '").concat(hookObject.path, "' service must return a promise"));
                  }
                  resolve(result);
                });
                return promise.then(function (result) {
                  hookObject.result = result;
                  return hookObject;
                }).catch(function (error) {
                  error.hook = hookObject;
                  throw error;
                });
              }) // Run `after` hooks
              .then(function (hookObject) {
                var afterHookObject = Object.assign({}, hookObject, {
                  type: 'after'
                });
                return processHooks.call(service, hooks.after, afterHookObject);
              }) // Run `errors` hooks
              .catch(function (error) {
                var errorHookObject = Object.assign({}, error.hook, {
                  type: 'error',
                  original: error.hook,
                  error: error,
                  result: undefined
                });
                return processHooks.call(service, hooks.error, errorHookObject).catch(function (error) {
                  var errorHookObject = Object.assign({}, error.hook, {
                    error: error,
                    result: undefined
                  });
                  return errorHookObject;
                });
              }) // Run `finally` hooks
              .then(function (hookObject) {
                return processHooks.call(service, hooks.finally, hookObject).catch(function (error) {
                  var errorHookObject = Object.assign({}, error.hook, {
                    error: error,
                    result: undefined
                  });
                  return errorHookObject;
                });
              }) // Resolve with a result or reject with an error
              .then(function (hookObject) {
                if (typeof hookObject.error !== 'undefined' && typeof hookObject.result === 'undefined') {
                  return Promise.reject(returnHook ? hookObject : hookObject.error);
                } else {
                  return returnHook ? hookObject : hookObject.result;
                }
              });
            };
          };
        }; // A service mixin that adds `service.hooks()` method and functionality

        var hookMixin = exports.hookMixin = function hookMixin(service) {
          if (typeof service.hooks === 'function') {
            return;
          }
          service.methods = Object.getOwnPropertyNames(service).filter(function (key) {
            return typeof service[key] === 'function' && service[key][ACTIVATE_HOOKS];
          }).reduce(function (result, methodName) {
            result[methodName] = service[methodName][ACTIVATE_HOOKS];
            return result;
          }, service.methods || {});
          Object.assign(service.methods, {
            find: ['params'],
            get: ['id', 'params'],
            create: ['data', 'params'],
            update: ['id', 'data', 'params'],
            patch: ['id', 'data', 'params'],
            remove: ['id', 'params']
          });
          var app = this;
          var methodNames = Object.keys(service.methods); // Assemble the mixin object that contains all "hooked" service methods

          var mixin = methodNames.reduce(function (mixin, method) {
            if (typeof service[method] !== 'function') {
              return mixin;
            }
            mixin[method] = function () {
              var service = this;
              var args = Array.from(arguments);
              var original = service._super.bind(service);
              return withHooks({
                app: app,
                service: service,
                method: method,
                original: original
              })({
                before: getHooks(app, service, 'before', method),
                after: getHooks(app, service, 'after', method, true),
                error: getHooks(app, service, 'error', method, true),
                finally: getHooks(app, service, 'finally', method, true)
              }).apply(void 0, _toConsumableArray(args));
            };
            return mixin;
          }, {}); // Add .hooks method and properties to the service

          enableHooks(service, methodNames, app.hookTypes);
          service.mixin(mixin);
        };
        module.exports = function () {
          return function (app) {
            // We store a reference of all supported hook types on the app
            // in case someone needs it
            Object.assign(app, {
              hookTypes: ['before', 'after', 'error', 'finally']
            }); // Add functionality for hooks to be registered as app.hooks

            enableHooks(app, app.methods, app.hookTypes);
            app.mixins.push(hookMixin);
          };
        };
        module.exports.withHooks = withHooks;
        module.exports.ACTIVATE_HOOKS = ACTIVATE_HOOKS;
        module.exports.activateHooks = function activateHooks(args) {
          return function (fn) {
            Object.defineProperty(fn, ACTIVATE_HOOKS, {
              value: args
            });
            return fn;
          };
        };

        /***/
      },

      /***/"../feathers/lib/index.js":
      /*!********************************!*\
        !*** ../feathers/lib/index.js ***!
        \********************************/
      /*! no static exports found */
      /***/
      function feathersLibIndexJs(module, exports, __webpack_require__) {
        var Proto = __webpack_require__( /*! uberproto */"../../node_modules/uberproto/lib/proto.js");
        var Application = __webpack_require__( /*! ./application */"../feathers/lib/application.js");
        var version = __webpack_require__( /*! ./version */"../feathers/lib/version.js");
        var _require = __webpack_require__( /*! ./hooks */"../feathers/lib/hooks/index.js"),
          ACTIVATE_HOOKS = _require.ACTIVATE_HOOKS,
          activateHooks = _require.activateHooks; // A base object Prototype that does not inherit from a
        // potentially polluted Object prototype

        var baseObject = Object.create(null);
        function createApplication() {
          var app = Object.create(baseObject); // Mix in the base application

          Proto.mixin(Application, app);
          app.init();
          return app;
        }
        createApplication.version = version;
        createApplication.ACTIVATE_HOOKS = ACTIVATE_HOOKS;
        createApplication.activateHooks = activateHooks;
        module.exports = createApplication; // For better ES module (TypeScript) compatibility

        module.exports.default = createApplication;

        /***/
      },

      /***/"../feathers/lib/version.js":
      /*!**********************************!*\
        !*** ../feathers/lib/version.js ***!
        \**********************************/
      /*! no static exports found */
      /***/
      function feathersLibVersionJs(module, exports) {
        module.exports = '4.5.0';

        /***/
      },

      /***/"../primus-client/lib/index.js":
      /*!*************************************!*\
        !*** ../primus-client/lib/index.js ***!
        \*************************************/
      /*! no static exports found */
      /***/
      function primusClientLibIndexJs(module, exports, __webpack_require__) {
        var Service = __webpack_require__( /*! @feathersjs/transport-commons/client */"../transport-commons/client.js");
        function primusClient(connection, options) {
          if (!connection) {
            throw new Error('Primus connection needs to be provided');
          }
          var defaultService = function defaultService(name) {
            return new Service(Object.assign({}, options, {
              name: name,
              connection: connection,
              method: 'send'
            }));
          };
          var initialize = function initialize(app) {
            if (typeof app.defaultService === 'function') {
              throw new Error('Only one default client provider can be configured');
            }
            app.primus = connection;
            app.defaultService = defaultService;
          };
          initialize.Service = Service;
          initialize.service = defaultService;
          return initialize;
        }
        module.exports = primusClient;
        module.exports.default = primusClient;

        /***/
      },

      /***/"../rest-client/lib/angular-http-client.js":
      /*!*************************************************!*\
        !*** ../rest-client/lib/angular-http-client.js ***!
        \*************************************************/
      /*! no static exports found */
      /***/
      function restClientLibAngularHttpClientJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var AngularHttpService = /*#__PURE__*/
        function (_Base) {
          _inherits(AngularHttpService, _Base);
          function AngularHttpService() {
            _classCallCheck(this, AngularHttpService);
            return _possibleConstructorReturn(this, _getPrototypeOf(AngularHttpService).apply(this, arguments));
          }
          _createClass(AngularHttpService, [{
            key: "request",
            value: function request(options, params) {
              var httpClient = this.connection;
              var HttpHeaders = this.options.HttpHeaders;
              if (!httpClient || !HttpHeaders) {
                throw new Error("Please pass angular's 'httpClient' (instance) and and object with 'HttpHeaders' (class) to feathers-rest");
              }
              var url = options.url;
              var _params$connection = params.connection,
                connection = _params$connection === void 0 ? {} : _params$connection;
              var headers = new HttpHeaders(Object.assign({
                Accept: 'application/json'
              }, this.options.headers, options.headers, connection.headers));
              var requestOptions = Object.assign({
                // method: options.method,
                body: options.body
              }, params.connection, {
                headers: headers
              });
              return new Promise(function (resolve, reject) {
                httpClient.request(options.method, url, requestOptions).subscribe(resolve, reject);
              }).catch(function (error) {
                var e = error.error;
                if (e) {
                  throw typeof e === 'string' ? JSON.parse(e) : e;
                }
                throw error;
              });
            }
          }]);
          return AngularHttpService;
        }(Base);
        module.exports = AngularHttpService;

        /***/
      },

      /***/"../rest-client/lib/angular.js":
      /*!*************************************!*\
        !*** ../rest-client/lib/angular.js ***!
        \*************************************/
      /*! no static exports found */
      /***/
      function restClientLibAngularJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var AngularService = /*#__PURE__*/
        function (_Base) {
          _inherits(AngularService, _Base);
          function AngularService() {
            _classCallCheck(this, AngularService);
            return _possibleConstructorReturn(this, _getPrototypeOf(AngularService).apply(this, arguments));
          }
          _createClass(AngularService, [{
            key: "request",
            value: function request(options, params) {
              var http = this.connection;
              var Headers = this.options.Headers;
              if (!http || !Headers) {
                throw new Error("Please pass angular's 'http' (instance) and and object with 'Headers' (class) to feathers-rest");
              }
              var url = options.url;
              var _params$connection = params.connection,
                connection = _params$connection === void 0 ? {} : _params$connection;
              var headers = new Headers(Object.assign({
                Accept: 'application/json'
              }, this.options.headers, options.headers, connection.headers));
              var requestOptions = Object.assign({
                method: options.method,
                body: options.body
              }, connection, {
                headers: headers
              });
              return new Promise(function (resolve, reject) {
                http.request(url, requestOptions).subscribe(resolve, reject);
              }).then(function (res) {
                return res.json();
              }).catch(function (error) {
                var response = error.response || error;
                throw response instanceof Error ? response : response.json() || response;
              });
            }
          }]);
          return AngularService;
        }(Base);
        module.exports = AngularService;

        /***/
      },

      /***/"../rest-client/lib/axios.js":
      /*!***********************************!*\
        !*** ../rest-client/lib/axios.js ***!
        \***********************************/
      /*! no static exports found */
      /***/
      function restClientLibAxiosJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var AxiosService = /*#__PURE__*/
        function (_Base) {
          _inherits(AxiosService, _Base);
          function AxiosService() {
            _classCallCheck(this, AxiosService);
            return _possibleConstructorReturn(this, _getPrototypeOf(AxiosService).apply(this, arguments));
          }
          _createClass(AxiosService, [{
            key: "request",
            value: function request(options, params) {
              var config = Object.assign({
                url: options.url,
                method: options.method,
                data: options.body,
                headers: Object.assign({
                  Accept: 'application/json'
                }, this.options.headers, options.headers)
              }, params.connection);
              return this.connection.request(config).then(function (res) {
                return res.data;
              }).catch(function (error) {
                var response = error.response || error;
                throw response instanceof Error ? response : response.data || response;
              });
            }
          }]);
          return AxiosService;
        }(Base);
        module.exports = AxiosService;

        /***/
      },

      /***/"../rest-client/lib/base.js":
      /*!**********************************!*\
        !*** ../rest-client/lib/base.js ***!
        \**********************************/
      /*! no static exports found */
      /***/
      function restClientLibBaseJs(module, exports, __webpack_require__) {
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        var qs = __webpack_require__( /*! qs */"../../node_modules/qs/lib/index.js");
        var _require = __webpack_require__( /*! @feathersjs/errors */"../errors/lib/index.js"),
          Unavailable = _require.Unavailable;
        var _require2 = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js"),
          _ = _require2._;
        var _require3 = __webpack_require__( /*! @feathersjs/commons */"../commons/lib/index.js"),
          stripSlashes = _require3.stripSlashes;
        var _require4 = __webpack_require__( /*! @feathersjs/errors */"../errors/lib/index.js"),
          convert = _require4.convert;
        function toError(error) {
          if (error.code === 'ECONNREFUSED') {
            throw new Unavailable(error.message, _.pick(error, 'address', 'port', 'config'));
          }
          throw convert(error);
        }
        var Base = /*#__PURE__*/
        function () {
          function Base(settings) {
            _classCallCheck(this, Base);
            this.name = stripSlashes(settings.name);
            this.options = settings.options;
            this.connection = settings.connection;
            this.base = "".concat(settings.base, "/").concat(this.name);
          }
          _createClass(Base, [{
            key: "makeUrl",
            value: function makeUrl(query, id) {
              query = query || {};
              var url = this.base;
              if (typeof id !== 'undefined' && id !== null) {
                url += "/".concat(encodeURIComponent(id));
              }
              return url + this.getQuery(query);
            }
          }, {
            key: "getQuery",
            value: function getQuery(query) {
              if (Object.keys(query).length !== 0) {
                var queryString = qs.stringify(query);
                return "?".concat(queryString);
              }
              return '';
            }
          }, {
            key: "find",
            value: function find() {
              var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return this.request({
                url: this.makeUrl(params.query),
                method: 'GET',
                headers: Object.assign({}, params.headers)
              }, params).catch(toError);
            }
          }, {
            key: "get",
            value: function get(id) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              if (typeof id === 'undefined') {
                return Promise.reject(new Error("id for 'get' can not be undefined"));
              }
              return this.request({
                url: this.makeUrl(params.query, id),
                method: 'GET',
                headers: Object.assign({}, params.headers)
              }, params).catch(toError);
            }
          }, {
            key: "create",
            value: function create(body) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return this.request({
                url: this.makeUrl(params.query),
                body: body,
                method: 'POST',
                headers: Object.assign({
                  'Content-Type': 'application/json'
                }, params.headers)
              }, params).catch(toError);
            }
          }, {
            key: "update",
            value: function update(id, body) {
              var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              if (typeof id === 'undefined') {
                return Promise.reject(new Error("id for 'update' can not be undefined, only 'null' when updating multiple entries"));
              }
              return this.request({
                url: this.makeUrl(params.query, id),
                body: body,
                method: 'PUT',
                headers: Object.assign({
                  'Content-Type': 'application/json'
                }, params.headers)
              }, params).catch(toError);
            }
          }, {
            key: "patch",
            value: function patch(id, body) {
              var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              if (typeof id === 'undefined') {
                return Promise.reject(new Error("id for 'patch' can not be undefined, only 'null' when updating multiple entries"));
              }
              return this.request({
                url: this.makeUrl(params.query, id),
                body: body,
                method: 'PATCH',
                headers: Object.assign({
                  'Content-Type': 'application/json'
                }, params.headers)
              }, params).catch(toError);
            }
          }, {
            key: "remove",
            value: function remove(id) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              if (typeof id === 'undefined') {
                return Promise.reject(new Error("id for 'remove' can not be undefined, only 'null' when removing multiple entries"));
              }
              return this.request({
                url: this.makeUrl(params.query, id),
                method: 'DELETE',
                headers: Object.assign({}, params.headers)
              }, params).catch(toError);
            }
          }]);
          return Base;
        }();
        module.exports = Base;

        /***/
      },

      /***/"../rest-client/lib/fetch.js":
      /*!***********************************!*\
        !*** ../rest-client/lib/fetch.js ***!
        \***********************************/
      /*! no static exports found */
      /***/
      function restClientLibFetchJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var FetchService = /*#__PURE__*/
        function (_Base) {
          _inherits(FetchService, _Base);
          function FetchService() {
            _classCallCheck(this, FetchService);
            return _possibleConstructorReturn(this, _getPrototypeOf(FetchService).apply(this, arguments));
          }
          _createClass(FetchService, [{
            key: "request",
            value: function request(options, params) {
              var fetchOptions = Object.assign({}, options, params.connection);
              fetchOptions.headers = Object.assign({
                Accept: 'application/json'
              }, this.options.headers, fetchOptions.headers);
              if (options.body) {
                fetchOptions.body = JSON.stringify(options.body);
              }
              var fetch = this.connection;
              return fetch(options.url, fetchOptions).then(this.checkStatus).then(function (response) {
                if (response.status === 204) {
                  return null;
                }
                return response.json();
              });
            }
          }, {
            key: "checkStatus",
            value: function checkStatus(response) {
              if (response.ok) {
                return response;
              }
              return response.json().then(function (error) {
                error.response = response;
                throw error;
              });
            }
          }]);
          return FetchService;
        }(Base);
        module.exports = FetchService;

        /***/
      },

      /***/"../rest-client/lib/index.js":
      /*!***********************************!*\
        !*** ../rest-client/lib/index.js ***!
        \***********************************/
      /*! no static exports found */
      /***/
      function restClientLibIndexJs(module, exports, __webpack_require__) {
        var jQueryClient = __webpack_require__( /*! ./jquery */"../rest-client/lib/jquery.js");
        var SuperagentClient = __webpack_require__( /*! ./superagent */"../rest-client/lib/superagent.js");
        var RequestClient = __webpack_require__( /*! ./request */"../rest-client/lib/request.js");
        var FetchClient = __webpack_require__( /*! ./fetch */"../rest-client/lib/fetch.js");
        var AxiosClient = __webpack_require__( /*! ./axios */"../rest-client/lib/axios.js");
        var AngularClient = __webpack_require__( /*! ./angular */"../rest-client/lib/angular.js");
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var AngularHttpClient = __webpack_require__( /*! ./angular-http-client */"../rest-client/lib/angular-http-client.js");
        var transports = {
          jquery: jQueryClient,
          superagent: SuperagentClient,
          request: RequestClient,
          fetch: FetchClient,
          axios: AxiosClient,
          angular: AngularClient,
          angularHttpClient: AngularHttpClient
        };
        function restClient() {
          var base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var result = {
            Base: Base
          };
          Object.keys(transports).forEach(function (key) {
            result[key] = function (connection) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var Service = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : transports[key];
              if (!connection) {
                throw new Error("".concat(key, " has to be provided to feathers-rest"));
              }
              if (typeof options === 'function') {
                Service = options;
                options = {};
              }
              var defaultService = function defaultService(name) {
                return new Service({
                  base: base,
                  name: name,
                  connection: connection,
                  options: options
                });
              };
              var initialize = function initialize(app) {
                if (typeof app.defaultService === 'function') {
                  throw new Error('Only one default client provider can be configured');
                }
                app.rest = connection;
                app.defaultService = defaultService;
              };
              initialize.Service = Service;
              initialize.service = defaultService;
              return initialize;
            };
          });
          return result;
        }
        module.exports = Object.assign(restClient, {
          SuperagentClient: SuperagentClient,
          FetchClient: FetchClient,
          jQueryClient: jQueryClient,
          RequestClient: RequestClient,
          AxiosClient: AxiosClient,
          AngularClient: AngularClient,
          AngularHttpClient: AngularHttpClient
        });
        module.exports.default = restClient;

        /***/
      },

      /***/"../rest-client/lib/jquery.js":
      /*!************************************!*\
        !*** ../rest-client/lib/jquery.js ***!
        \************************************/
      /*! no static exports found */
      /***/
      function restClientLibJqueryJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var JQueryService = /*#__PURE__*/
        function (_Base) {
          _inherits(JQueryService, _Base);
          function JQueryService() {
            _classCallCheck(this, JQueryService);
            return _possibleConstructorReturn(this, _getPrototypeOf(JQueryService).apply(this, arguments));
          }
          _createClass(JQueryService, [{
            key: "request",
            value: function request(options, params) {
              var _this = this;
              var _params$connection = params.connection,
                connection = _params$connection === void 0 ? {} : _params$connection;
              var headers = Object.assign({}, options.headers, this.options.headers, connection.headers);
              var opts = Object.assign({
                dataType: options.type || 'json'
              }, connection, options, {
                headers: headers
              });
              if (options.body) {
                opts.data = JSON.stringify(options.body);
                opts.contentType = 'application/json';
              }
              delete opts.type;
              delete opts.body;
              return new Promise(function (resolve, reject) {
                _this.connection.ajax(opts).then(resolve, function (xhr) {
                  var error = xhr.responseText;
                  try {
                    error = JSON.parse(error);
                  } catch (e) {
                    error = new Error(xhr.responseText);
                  }
                  error.xhr = error.response = xhr;
                  reject(error);
                });
              });
            }
          }]);
          return JQueryService;
        }(Base);
        module.exports = JQueryService;

        /***/
      },

      /***/"../rest-client/lib/request.js":
      /*!*************************************!*\
        !*** ../rest-client/lib/request.js ***!
        \*************************************/
      /*! no static exports found */
      /***/
      function restClientLibRequestJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var RequestService = /*#__PURE__*/
        function (_Base) {
          _inherits(RequestService, _Base);
          function RequestService() {
            _classCallCheck(this, RequestService);
            return _possibleConstructorReturn(this, _getPrototypeOf(RequestService).apply(this, arguments));
          }
          _createClass(RequestService, [{
            key: "request",
            value: function request(options, params) {
              var _this = this;
              return new Promise(function (resolve, reject) {
                var _params$connection = params.connection,
                  connection = _params$connection === void 0 ? {} : _params$connection;
                var headers = Object.assign({}, options.headers, connection.headers);
                _this.connection(Object.assign({
                  json: true
                }, options, params.connection, {
                  headers: headers
                }), function (error, res, data) {
                  if (error) {
                    return reject(error);
                  }
                  if (!error && res.statusCode >= 400) {
                    if (typeof data === 'string') {
                      return reject(new Error(data));
                    }
                    data.response = res;
                    return reject(Object.assign(new Error(data.message), data));
                  }
                  resolve(data);
                });
              });
            }
          }]);
          return RequestService;
        }(Base);
        module.exports = RequestService;

        /***/
      },

      /***/"../rest-client/lib/superagent.js":
      /*!****************************************!*\
        !*** ../rest-client/lib/superagent.js ***!
        \****************************************/
      /*! no static exports found */
      /***/
      function restClientLibSuperagentJs(module, exports, __webpack_require__) {
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        var Base = __webpack_require__( /*! ./base */"../rest-client/lib/base.js");
        var SuperagentService = /*#__PURE__*/
        function (_Base) {
          _inherits(SuperagentService, _Base);
          function SuperagentService() {
            _classCallCheck(this, SuperagentService);
            return _possibleConstructorReturn(this, _getPrototypeOf(SuperagentService).apply(this, arguments));
          }
          _createClass(SuperagentService, [{
            key: "request",
            value: function request(options, params) {
              var superagent = this.connection(options.method, options.url).set(this.options.headers || {}).set('Accept', 'application/json').set(params.connection || {}).set(options.headers || {}).type(options.type || 'json');
              return new Promise(function (resolve, reject) {
                superagent.set(options.headers);
                if (options.body) {
                  superagent.send(options.body);
                }
                superagent.end(function (error, res) {
                  if (error) {
                    try {
                      var response = error.response;
                      error = JSON.parse(error.response.text);
                      error.response = response;
                    } catch (e) {}
                    return reject(error);
                  }
                  resolve(res && res.body);
                });
              });
            }
          }]);
          return SuperagentService;
        }(Base);
        module.exports = SuperagentService;

        /***/
      },

      /***/"../socketio-client/lib/index.js":
      /*!***************************************!*\
        !*** ../socketio-client/lib/index.js ***!
        \***************************************/
      /*! no static exports found */
      /***/
      function socketioClientLibIndexJs(module, exports, __webpack_require__) {
        var Service = __webpack_require__( /*! @feathersjs/transport-commons/client */"../transport-commons/client.js");
        function socketioClient(connection, options) {
          if (!connection) {
            throw new Error('Socket.io connection needs to be provided');
          }
          var defaultService = function defaultService(name) {
            var _this = this;
            var events = Object.keys(this.eventMappings || {}).map(function (method) {
              return _this.eventMappings[method];
            });
            var settings = Object.assign({}, options, {
              events: events,
              name: name,
              connection: connection,
              method: 'emit'
            });
            return new Service(settings);
          };
          var initialize = function initialize(app) {
            if (typeof app.defaultService === 'function') {
              throw new Error('Only one default client provider can be configured');
            }
            app.io = connection;
            app.defaultService = defaultService;
          };
          initialize.Service = Service;
          initialize.service = defaultService;
          return initialize;
        }
        module.exports = socketioClient;
        module.exports.default = socketioClient;

        /***/
      },

      /***/"../transport-commons/client.js":
      /*!**************************************!*\
        !*** ../transport-commons/client.js ***!
        \**************************************/
      /*! no static exports found */
      /***/
      function transportCommonsClientJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__( /*! ./lib/client */"../transport-commons/lib/client.js").Service;

        /***/
      },

      /***/"../transport-commons/lib/client.js":
      /*!******************************************!*\
        !*** ../transport-commons/lib/client.js ***!
        \******************************************/
      /*! no static exports found */
      /***/
      function transportCommonsLibClientJs(module, exports, __webpack_require__) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        var __importDefault = this && this.__importDefault || function (mod) {
          return mod && mod.__esModule ? mod : {
            "default": mod
          };
        };
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var debug_1 = __importDefault(__webpack_require__( /*! debug */"../../node_modules/debug/src/browser.js"));
        var errors_1 = __webpack_require__( /*! @feathersjs/errors */"../errors/lib/index.js");
        var debug = debug_1.default('@feathersjs/transport-commons/client');
        var namespacedEmitterMethods = ['addListener', 'emit', 'listenerCount', 'listeners', 'on', 'once', 'prependListener', 'prependOnceListener', 'removeAllListeners', 'removeListener'];
        var otherEmitterMethods = ['eventNames', 'getMaxListeners', 'setMaxListeners'];
        var addEmitterMethods = function addEmitterMethods(service) {
          otherEmitterMethods.forEach(function (method) {
            service[method] = function () {
              var _this$connection;
              if (typeof this.connection[method] !== 'function') {
                throw new Error("Can not call '".concat(method, "' on the client service connection"));
              }
              return (_this$connection = this.connection)[method].apply(_this$connection, arguments);
            };
          }); // Methods that should add the namespace (service path)

          namespacedEmitterMethods.forEach(function (method) {
            service[method] = function (name) {
              var _this$connection2;
              if (typeof this.connection[method] !== 'function') {
                throw new Error("Can not call '".concat(method, "' on the client service connection"));
              }
              var eventName = "".concat(this.path, " ").concat(name);
              debug("Calling emitter method ".concat(method, " with ") + "namespaced event '".concat(eventName, "'"));
              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }
              var result = (_this$connection2 = this.connection)[method].apply(_this$connection2, [eventName].concat(args));
              return result === this.connection ? this : result;
            };
          });
        };
        var Service = /*#__PURE__*/
        function () {
          function Service(options) {
            _classCallCheck(this, Service);
            this.events = options.events;
            this.path = options.name;
            this.connection = options.connection;
            this.method = options.method;
            this.timeout = options.timeout || 5000;
            addEmitterMethods(this);
          }
          _createClass(Service, [{
            key: "send",
            value: function send(method) {
              var _this = this;
              for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
              }
              return new Promise(function (resolve, reject) {
                var _this$connection3;
                var timeoutId = setTimeout(function () {
                  return reject(new errors_1.Timeout("Timeout of ".concat(_this.timeout, "ms exceeded calling ").concat(method, " on ").concat(_this.path), {
                    timeout: _this.timeout,
                    method: method,
                    path: _this.path
                  }));
                }, _this.timeout);
                args.unshift(method, _this.path);
                args.push(function (error, data) {
                  error = errors_1.convert(error);
                  clearTimeout(timeoutId);
                  return error ? reject(error) : resolve(data);
                });
                debug("Sending socket.".concat(_this.method), args);
                (_this$connection3 = _this.connection)[_this.method].apply(_this$connection3, args);
              });
            }
          }, {
            key: "find",
            value: function find() {
              var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return this.send('find', params.query || {});
            }
          }, {
            key: "get",
            value: function get(id) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return this.send('get', id, params.query || {});
            }
          }, {
            key: "create",
            value: function create(data) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return this.send('create', data, params.query || {});
            }
          }, {
            key: "update",
            value: function update(id, data) {
              var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              return this.send('update', id, data, params.query || {});
            }
          }, {
            key: "patch",
            value: function patch(id, data) {
              var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              return this.send('patch', id, data, params.query || {});
            }
          }, {
            key: "remove",
            value: function remove(id) {
              var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return this.send('remove', id, params.query || {});
            } // `off` is actually not part of the Node event emitter spec
            // but we are adding it since everybody is expecting it because
            // of the emitter-component Socket.io is using
          }, {
            key: "off",
            value: function off(name) {
              for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = arguments[_key3];
              }
              if (typeof this.connection.off === 'function') {
                var _this$connection4;
                var result = (_this$connection4 = this.connection).off.apply(_this$connection4, ["".concat(this.path, " ").concat(name)].concat(args));
                return result === this.connection ? this : result;
              } else if (args.length === 0) {
                // @ts-ignore
                return this.removeAllListeners(name);
              } // @ts-ignore

              return this.removeListener.apply(this, [name].concat(args));
            }
          }]);
          return Service;
        }();
        exports.Service = Service;

        /***/
      },

      /***/"./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/
      /*! no static exports found */
      /***/
      function srcIndexJs(module, exports, __webpack_require__) {
        var feathers = __webpack_require__( /*! @feathersjs/feathers */"../feathers/lib/index.js");
        var errors = __webpack_require__( /*! @feathersjs/errors */"../errors/lib/index.js");
        var authentication = __webpack_require__( /*! @feathersjs/authentication-client */"../authentication-client/lib/index.js");
        var rest = __webpack_require__( /*! @feathersjs/rest-client */"../rest-client/lib/index.js");
        var socketio = __webpack_require__( /*! @feathersjs/socketio-client */"../socketio-client/lib/index.js");
        var primus = __webpack_require__( /*! @feathersjs/primus-client */"../primus-client/lib/index.js");
        Object.assign(feathers, {
          errors: errors,
          socketio: socketio,
          primus: primus,
          rest: rest,
          authentication: authentication
        });
        module.exports = feathers;

        /***/
      }

      /******/
    })
  );
});